
// // // // // // // // // // // // // // // import GDPRPolicyLink from "../components/GDPRPolicyLink";
// // // // // // // // // // // // // // // import { useState, useRef } from "react";
// // // // // // // // // // // // // // // import {
// // // // // // // // // // // // // // //   Card,
// // // // // // // // // // // // // // //   CardContent,
// // // // // // // // // // // // // // //   Typography,
// // // // // // // // // // // // // // //   TextField,
// // // // // // // // // // // // // // //   Button,
// // // // // // // // // // // // // // //   Box,
// // // // // // // // // // // // // // //   FormLabel,
// // // // // // // // // // // // // // //   RadioGroup,
// // // // // // // // // // // // // // //   FormControlLabel,
// // // // // // // // // // // // // // //   Radio,
// // // // // // // // // // // // // // //   InputAdornment,
// // // // // // // // // // // // // // //   Checkbox,
// // // // // // // // // // // // // // //   Alert,
// // // // // // // // // // // // // // //   IconButton,
// // // // // // // // // // // // // // //   FormControl,
// // // // // // // // // // // // // // // } from "@mui/material";
// // // // // // // // // // // // // // // import { SketchPicker } from "react-color";
// // // // // // // // // // // // // // // import axiosClient from "../axiosClient";
// // // // // // // // // // // // // // // import { useTranslation } from "react-i18next";
// // // // // // // // // // // // // // // import PhoneField from "../components/PhoneField";
// // // // // // // // // // // // // // // import { Visibility, VisibilityOff } from "@mui/icons-material";

// // // // // // // // // // // // // // // const UserForm = () => {
// // // // // // // // // // // // // // //   const nameRef = useRef(null);
// // // // // // // // // // // // // // //   const surnameRef = useRef(null);
// // // // // // // // // // // // // // //   const dateRef = useRef(null);
// // // // // // // // // // // // // // //   const passwordRef = useRef(null);
// // // // // // // // // // // // // // //   const emailRef = useRef(null);
// // // // // // // // // // // // // // //   const idCardRef = useRef(null);
// // // // // // // // // // // // // // //   const cityRef = useRef(null);
// // // // // // // // // // // // // // //   const specializationsRef = useRef(null); 

// // // // // // // // // // // // // // //   const [gender, setGender] = useState("");
// // // // // // // // // // // // // // //   const [role, setRole] = useState("TECHNICIAN"); 
// // // // // // // // // // // // // // //   const [error, setError] = useState();
// // // // // // // // // // // // // // //   const [message, setMessage] = useState();
// // // // // // // // // // // // // // //   const [color, setColor] = useState("#3f51b5");
// // // // // // // // // // // // // // //   const [phone, setPhone] = useState("+357");
// // // // // // // // // // // // // // //   const [hardcopyConsent, setHardcopyConsent] = useState(false);
// // // // // // // // // // // // // // //   const [errors, setErrors] = useState({});
// // // // // // // // // // // // // // //   const { t } = useTranslation();
// // // // // // // // // // // // // // //   const [showPassword, setShowPassword] = useState(false);

// // // // // // // // // // // // // // //   const normalizePhone = (value) => {
// // // // // // // // // // // // // // //     if (!value) return "";
// // // // // // // // // // // // // // //     const trimmed = String(value).trim();
// // // // // // // // // // // // // // //     if (trimmed === "+357") return "";
// // // // // // // // // // // // // // //     return trimmed.startsWith("+") ? trimmed : `+${trimmed}`;
// // // // // // // // // // // // // // //   };

// // // // // // // // // // // // // // //   const handleSubmit = (event) => {
// // // // // // // // // // // // // // //     event.preventDefault();
// // // // // // // // // // // // // // //     setErrors({});
// // // // // // // // // // // // // // //     setError(undefined);
// // // // // // // // // // // // // // //     setMessage(undefined);

// // // // // // // // // // // // // // //     const emailVal = emailRef.current?.value || "";
// // // // // // // // // // // // // // //     const passwordVal = passwordRef.current?.value || "";
// // // // // // // // // // // // // // //     const phoneVal = normalizePhone(phone);

// // // // // // // // // // // // // // //     const localErrors = {};
// // // // // // // // // // // // // // //     if (!emailVal.includes("@")) localErrors.email = t("Invalid email");
// // // // // // // // // // // // // // //     if (passwordVal.length < 8) localErrors.password = t("Min 8 characters");
// // // // // // // // // // // // // // //     if (!phoneVal) localErrors.phone_number = t("Phone is required");

// // // // // // // // // // // // // // //     if (Object.keys(localErrors).length) {
// // // // // // // // // // // // // // //       setErrors(localErrors);
// // // // // // // // // // // // // // //       return;
// // // // // // // // // // // // // // //     }

// // // // // // // // // // // // // // //     const payload = {
// // // // // // // // // // // // // // //       user_role: role, 
// // // // // // // // // // // // // // //       username: emailVal,
// // // // // // // // // // // // // // //       email: emailVal,
// // // // // // // // // // // // // // //       password: passwordVal,
// // // // // // // // // // // // // // //       first_name: nameRef.current?.value || "",
// // // // // // // // // // // // // // //       last_name: surnameRef.current?.value || "",
// // // // // // // // // // // // // // //       phone_number: phoneVal,
// // // // // // // // // // // // // // //       gender: gender || null,
// // // // // // // // // // // // // // //       date_birth: dateRef.current?.value || null,
// // // // // // // // // // // // // // //       id_card: idCardRef.current?.value || "",
// // // // // // // // // // // // // // //       city: cityRef.current?.value || "",
// // // // // // // // // // // // // // //       hardcopy_consent: hardcopyConsent,
// // // // // // // // // // // // // // //       ...(role === "TECHNICIAN" ? { color: color, specializations: specializationsRef.current?.value || "" } : {})
// // // // // // // // // // // // // // //     };

// // // // // // // // // // // // // // //     axiosClient
// // // // // // // // // // // // // // //       .post("auth/users/", payload) 
// // // // // // // // // // // // // // //       .then(() => {
// // // // // // // // // // // // // // //         setMessage(t("User added successfully"));
// // // // // // // // // // // // // // //         handleReset();
// // // // // // // // // // // // // // //       })
// // // // // // // // // // // // // // //       .catch((err) => {
// // // // // // // // // // // // // // //         const backendErrors = err.response?.data;
// // // // // // // // // // // // // // //         if (backendErrors && typeof backendErrors === 'object') {
// // // // // // // // // // // // // // //           const firstErrorKey = Object.keys(backendErrors)[0];
// // // // // // // // // // // // // // //           const firstErrorMsg = Array.isArray(backendErrors[firstErrorKey]) 
// // // // // // // // // // // // // // //             ? backendErrors[firstErrorKey][0] 
// // // // // // // // // // // // // // //             : backendErrors[firstErrorKey];
          
// // // // // // // // // // // // // // //           setError(`${firstErrorKey}: ${firstErrorMsg}`);
// // // // // // // // // // // // // // //           setErrors(backendErrors);
// // // // // // // // // // // // // // //         } else {
// // // // // // // // // // // // // // //           setError(t("Failed to create user. Check if email or ID Card is unique."));
// // // // // // // // // // // // // // //         }
// // // // // // // // // // // // // // //       });
// // // // // // // // // // // // // // //   };

// // // // // // // // // // // // // // //   const handleReset = () => {
// // // // // // // // // // // // // // //     setRole("TECHNICIAN");
// // // // // // // // // // // // // // //     setGender("");
// // // // // // // // // // // // // // //     setPhone("+357");
// // // // // // // // // // // // // // //     setHardcopyConsent(false);
// // // // // // // // // // // // // // //     setErrors({});
// // // // // // // // // // // // // // //     [nameRef, surnameRef, dateRef, passwordRef, emailRef, idCardRef, cityRef, specializationsRef].forEach(ref => {
// // // // // // // // // // // // // // //       if (ref.current) ref.current.value = "";
// // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // //   };

// // // // // // // // // // // // // // //   return (
// // // // // // // // // // // // // // //     <Card elevation={16}>
// // // // // // // // // // // // // // //       <CardContent>
// // // // // // // // // // // // // // //         <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>{t("Create New User")}</Typography>
        
// // // // // // // // // // // // // // //         {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // // // // // // // // // // // // // //         {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// // // // // // // // // // // // // // //         <form onSubmit={handleSubmit}>
// // // // // // // // // // // // // // //           <Box display="flex" alignItems="center" sx={{ mb: 3 }}>
// // // // // // // // // // // // // // //             <FormLabel sx={{ mr: 2, fontWeight: 'bold' }}>{t("Role")}</FormLabel>
// // // // // // // // // // // // // // //             <RadioGroup row value={role} onChange={(e) => setRole(e.target.value)}>
// // // // // // // // // // // // // // //               <FormControlLabel value="RECEPTION" control={<Radio />} label={t("Reception")} />
// // // // // // // // // // // // // // //               <FormControlLabel value="ADMIN" control={<Radio />} label={t("Admin")} />
// // // // // // // // // // // // // // //               <FormControlLabel value="TECHNICIAN" control={<Radio />} label={t("Technician")} />
// // // // // // // // // // // // // // //               <FormControlLabel value="MAID" control={<Radio />} label={t("Maid")} />
// // // // // // // // // // // // // // //             </RadioGroup>
// // // // // // // // // // // // // // //           </Box>

// // // // // // // // // // // // // // //           <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
// // // // // // // // // // // // // // //             <TextField fullWidth label={t("Name")} inputRef={nameRef} required />
// // // // // // // // // // // // // // //             <TextField fullWidth label={t("Surname")} inputRef={surnameRef} required />
            
// // // // // // // // // // // // // // //             <TextField 
// // // // // // // // // // // // // // //                 fullWidth 
// // // // // // // // // // // // // // //                 label={t("Email")} 
// // // // // // // // // // // // // // //                 type="email" 
// // // // // // // // // // // // // // //                 inputRef={emailRef} 
// // // // // // // // // // // // // // //                 required 
// // // // // // // // // // // // // // //                 error={!!errors.email} 
// // // // // // // // // // // // // // //                 helperText={errors.email?.[0] || ""}
// // // // // // // // // // // // // // //             />
            
// // // // // // // // // // // // // // //             <TextField
// // // // // // // // // // // // // // //               fullWidth
// // // // // // // // // // // // // // //               label={t("Password")}
// // // // // // // // // // // // // // //               type={showPassword ? "text" : "password"}
// // // // // // // // // // // // // // //               inputRef={passwordRef}
// // // // // // // // // // // // // // //               required
// // // // // // // // // // // // // // //               error={!!errors.password}
// // // // // // // // // // // // // // //               helperText={errors.password?.[0] || ""}
// // // // // // // // // // // // // // //               InputProps={{
// // // // // // // // // // // // // // //                 endAdornment: (
// // // // // // // // // // // // // // //                   <InputAdornment position="end">
// // // // // // // // // // // // // // //                     <IconButton onClick={() => setShowPassword(!showPassword)}>{showPassword ? <VisibilityOff /> : <Visibility />}</IconButton>
// // // // // // // // // // // // // // //                   </InputAdornment>
// // // // // // // // // // // // // // //                 ),
// // // // // // // // // // // // // // //               }}
// // // // // // // // // // // // // // //             />

// // // // // // // // // // // // // // //             <Box>
// // // // // // // // // // // // // // //                 <PhoneField phone={phone} setPhone={setPhone} />
// // // // // // // // // // // // // // //                 {errors.phone_number && <Typography color="error" variant="caption">{errors.phone_number[0]}</Typography>}
// // // // // // // // // // // // // // //             </Box>

// // // // // // // // // // // // // // //             <TextField 
// // // // // // // // // // // // // // //                 fullWidth 
// // // // // // // // // // // // // // //                 label={t("ID CARD")} 
// // // // // // // // // // // // // // //                 inputRef={idCardRef} 
// // // // // // // // // // // // // // //                 error={!!errors.id_card}
// // // // // // // // // // // // // // //                 helperText={errors.id_card?.[0] || ""}
// // // // // // // // // // // // // // //             />

// // // // // // // // // // // // // // //             <TextField fullWidth label={t("Date of Birth")} type="date" inputRef={dateRef} InputLabelProps={{ shrink: true }} />
            
// // // // // // // // // // // // // // //             <FormControl fullWidth>
// // // // // // // // // // // // // // //               <FormLabel sx={{ fontSize: "0.8rem" }}>{t("GENDER (OPTIONAL)")}</FormLabel>
// // // // // // // // // // // // // // //               <RadioGroup row value={gender} onChange={(e) => setGender(e.target.value)}>
// // // // // // // // // // // // // // //                 <FormControlLabel value="M" control={<Radio size="small" />} label={t("MALE")} />
// // // // // // // // // // // // // // //                 <FormControlLabel value="F" control={<Radio size="small" />} label={t("FEMALE")} />
// // // // // // // // // // // // // // //               </RadioGroup>
// // // // // // // // // // // // // // //             </FormControl>
// // // // // // // // // // // // // // //           </Box>

// // // // // // // // // // // // // // //           {role === "TECHNICIAN" && (
// // // // // // // // // // // // // // //             <Box sx={{ mt: 3, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
// // // // // // // // // // // // // // //               <TextField fullWidth label={t("Specializations")} inputRef={specializationsRef} sx={{ mb: 2 }} />
// // // // // // // // // // // // // // //               <Typography variant="caption" sx={{ display: 'block', mb: 1 }}>{t("Calendar Color Selection")}</Typography>
// // // // // // // // // // // // // // //               <SketchPicker color={color} onChangeComplete={(c) => setColor(c.hex)} />
// // // // // // // // // // // // // // //             </Box>
// // // // // // // // // // // // // // //           )}

// // // // // // // // // // // // // // //           <Box mt={4} display="flex" gap={2}>
// // // // // // // // // // // // // // //             <Button type="submit" variant="contained" size="large">{t("SUBMIT")}</Button>
// // // // // // // // // // // // // // //             <Button type="button" variant="outlined" size="large" onClick={handleReset}>{t("RESET")}</Button>
// // // // // // // // // // // // // // //           </Box>
// // // // // // // // // // // // // // //         </form>
// // // // // // // // // // // // // // //       </CardContent>
// // // // // // // // // // // // // // //     </Card>
// // // // // // // // // // // // // // //   );
// // // // // // // // // // // // // // // };

// // // // // // // // // // // // // // // export default UserForm;

// // // // // // // // // // // // // // import GDPRPolicyLink from "../components/GDPRPolicyLink";
// // // // // // // // // // // // // // import { useState, useRef } from "react";
// // // // // // // // // // // // // // import {
// // // // // // // // // // // // // //   Card,
// // // // // // // // // // // // // //   CardContent,
// // // // // // // // // // // // // //   Typography,
// // // // // // // // // // // // // //   TextField,
// // // // // // // // // // // // // //   Button,
// // // // // // // // // // // // // //   Box,
// // // // // // // // // // // // // //   FormLabel,
// // // // // // // // // // // // // //   RadioGroup,
// // // // // // // // // // // // // //   FormControlLabel,
// // // // // // // // // // // // // //   Radio,
// // // // // // // // // // // // // //   InputAdornment,
// // // // // // // // // // // // // //   Checkbox,
// // // // // // // // // // // // // //   Alert,
// // // // // // // // // // // // // //   IconButton,
// // // // // // // // // // // // // //   FormControl,
// // // // // // // // // // // // // // } from "@mui/material";
// // // // // // // // // // // // // // import { SketchPicker } from "react-color";
// // // // // // // // // // // // // // import axiosClient from "../axiosClient";
// // // // // // // // // // // // // // import { useTranslation } from "react-i18next";
// // // // // // // // // // // // // // import PhoneField from "../components/PhoneField";
// // // // // // // // // // // // // // import { Visibility, VisibilityOff } from "@mui/icons-material";

// // // // // // // // // // // // // // const UserForm = () => {
// // // // // // // // // // // // // //   const nameRef = useRef(null);
// // // // // // // // // // // // // //   const surnameRef = useRef(null);
// // // // // // // // // // // // // //   const dateRef = useRef(null);
// // // // // // // // // // // // // //   const passwordRef = useRef(null);
// // // // // // // // // // // // // //   const emailRef = useRef(null);
// // // // // // // // // // // // // //   const idCardRef = useRef(null);
// // // // // // // // // // // // // //   const cityRef = useRef(null);
// // // // // // // // // // // // // //   const specializationsRef = useRef(null); 

// // // // // // // // // // // // // //   const [gender, setGender] = useState("");
// // // // // // // // // // // // // //   const [role, setRole] = useState("TECHNICIAN"); 
// // // // // // // // // // // // // //   const [error, setError] = useState();
// // // // // // // // // // // // // //   const [message, setMessage] = useState();
// // // // // // // // // // // // // //   const [color, setColor] = useState("#3f51b5");
// // // // // // // // // // // // // //   const [phone, setPhone] = useState("+357");
// // // // // // // // // // // // // //   const [hardcopyConsent, setHardcopyConsent] = useState(false);
// // // // // // // // // // // // // //   const [errors, setErrors] = useState({});
// // // // // // // // // // // // // //   const { t } = useTranslation();
// // // // // // // // // // // // // //   const [showPassword, setShowPassword] = useState(false);

// // // // // // // // // // // // // //   const normalizePhone = (value) => {
// // // // // // // // // // // // // //     if (!value) return "";
// // // // // // // // // // // // // //     const trimmed = String(value).trim();
// // // // // // // // // // // // // //     if (trimmed === "+357") return "";
// // // // // // // // // // // // // //     return trimmed.startsWith("+") ? trimmed : `+${trimmed}`;
// // // // // // // // // // // // // //   };

// // // // // // // // // // // // // //   const handleSubmit = (event) => {
// // // // // // // // // // // // // //     event.preventDefault();
// // // // // // // // // // // // // //     setErrors({});
// // // // // // // // // // // // // //     setError(undefined);
// // // // // // // // // // // // // //     setMessage(undefined);

// // // // // // // // // // // // // //     const emailVal = emailRef.current?.value || "";
// // // // // // // // // // // // // //     const passwordVal = passwordRef.current?.value || "";
// // // // // // // // // // // // // //     const phoneVal = normalizePhone(phone);

// // // // // // // // // // // // // //     const localErrors = {};
// // // // // // // // // // // // // //     if (!emailVal.includes("@")) localErrors.email = t("Invalid email");
// // // // // // // // // // // // // //     if (passwordVal.length < 8) localErrors.password = t("Min 8 characters");
// // // // // // // // // // // // // //     if (!phoneVal) localErrors.phone_number = t("Phone is required");

// // // // // // // // // // // // // //     if (Object.keys(localErrors).length) {
// // // // // // // // // // // // // //       setErrors(localErrors);
// // // // // // // // // // // // // //       return;
// // // // // // // // // // // // // //     }

// // // // // // // // // // // // // //     const payload = {
// // // // // // // // // // // // // //       user_role: role, 
// // // // // // // // // // // // // //       username: emailVal,
// // // // // // // // // // // // // //       email: emailVal,
// // // // // // // // // // // // // //       password: passwordVal,
// // // // // // // // // // // // // //       first_name: nameRef.current?.value || "",
// // // // // // // // // // // // // //       last_name: surnameRef.current?.value || "",
// // // // // // // // // // // // // //       phone_number: phoneVal,
// // // // // // // // // // // // // //       gender: gender || null,
// // // // // // // // // // // // // //       date_birth: dateRef.current?.value || null,
// // // // // // // // // // // // // //       id_card: idCardRef.current?.value || "",
// // // // // // // // // // // // // //       city: cityRef.current?.value || "",
// // // // // // // // // // // // // //       hardcopy_consent: hardcopyConsent,
// // // // // // // // // // // // // //       ...(role === "TECHNICIAN" ? { color: color, specializations: specializationsRef.current?.value || "" } : {})
// // // // // // // // // // // // // //     };

// // // // // // // // // // // // // //     axiosClient
// // // // // // // // // // // // // //       .post("auth/users/", payload) 
// // // // // // // // // // // // // //       .then(() => {
// // // // // // // // // // // // // //         setMessage(t("User added successfully"));
// // // // // // // // // // // // // //         handleReset();
// // // // // // // // // // // // // //       })
// // // // // // // // // // // // // //       .catch((err) => {
// // // // // // // // // // // // // //         const backendErrors = err.response?.data;
// // // // // // // // // // // // // //         if (backendErrors && typeof backendErrors === 'object') {
// // // // // // // // // // // // // //           const firstErrorKey = Object.keys(backendErrors)[0];
// // // // // // // // // // // // // //           const firstErrorMsg = Array.isArray(backendErrors[firstErrorKey]) 
// // // // // // // // // // // // // //             ? backendErrors[firstErrorKey][0] 
// // // // // // // // // // // // // //             : backendErrors[firstErrorKey];
          
// // // // // // // // // // // // // //           setError(`${firstErrorKey}: ${firstErrorMsg}`);
// // // // // // // // // // // // // //           setErrors(backendErrors);
// // // // // // // // // // // // // //         } else {
// // // // // // // // // // // // // //           setError(t("Failed to create user. Check if email or ID Card is unique."));
// // // // // // // // // // // // // //         }
// // // // // // // // // // // // // //       });
// // // // // // // // // // // // // //   };

// // // // // // // // // // // // // //   const handleReset = () => {
// // // // // // // // // // // // // //     setRole("TECHNICIAN");
// // // // // // // // // // // // // //     setGender("");
// // // // // // // // // // // // // //     setPhone("+357");
// // // // // // // // // // // // // //     setHardcopyConsent(false);
// // // // // // // // // // // // // //     setErrors({});
// // // // // // // // // // // // // //     [nameRef, surnameRef, dateRef, passwordRef, emailRef, idCardRef, cityRef, specializationsRef].forEach(ref => {
// // // // // // // // // // // // // //       if (ref.current) ref.current.value = "";
// // // // // // // // // // // // // //     });
// // // // // // // // // // // // // //   };

// // // // // // // // // // // // // //   return (
// // // // // // // // // // // // // //     <Card elevation={16}>
// // // // // // // // // // // // // //       <CardContent>
// // // // // // // // // // // // // //         <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>{t("Create New User")}</Typography>
        
// // // // // // // // // // // // // //         {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // // // // // // // // // // // // //         {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// // // // // // // // // // // // // //         <form onSubmit={handleSubmit}>
// // // // // // // // // // // // // //           <Box display="flex" alignItems="center" sx={{ mb: 3 }}>
// // // // // // // // // // // // // //             <FormLabel sx={{ mr: 2, fontWeight: 'bold' }}>{t("Role")}</FormLabel>
// // // // // // // // // // // // // //             <RadioGroup row value={role} onChange={(e) => setRole(e.target.value)}>
// // // // // // // // // // // // // //               <FormControlLabel value="RECEPTION" control={<Radio />} label={t("Reception")} />
// // // // // // // // // // // // // //               <FormControlLabel value="ADMIN" control={<Radio />} label={t("Admin")} />
// // // // // // // // // // // // // //               <FormControlLabel value="TECHNICIAN" control={<Radio />} label={t("Technician")} />
// // // // // // // // // // // // // //               <FormControlLabel value="MAID" control={<Radio />} label={t("Maid")} />
// // // // // // // // // // // // // //             </RadioGroup>
// // // // // // // // // // // // // //           </Box>

// // // // // // // // // // // // // //           <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
// // // // // // // // // // // // // //             <TextField fullWidth label={t("Name")} inputRef={nameRef} required />
// // // // // // // // // // // // // //             <TextField fullWidth label={t("Surname")} inputRef={surnameRef} required />
            
// // // // // // // // // // // // // //             <TextField 
// // // // // // // // // // // // // //                 fullWidth 
// // // // // // // // // // // // // //                 label={t("Email")} 
// // // // // // // // // // // // // //                 type="email" 
// // // // // // // // // // // // // //                 inputRef={emailRef} 
// // // // // // // // // // // // // //                 required 
// // // // // // // // // // // // // //                 error={!!errors.email} 
// // // // // // // // // // // // // //                 helperText={errors.email?.[0] || ""}
// // // // // // // // // // // // // //             />
            
// // // // // // // // // // // // // //             <TextField
// // // // // // // // // // // // // //               fullWidth
// // // // // // // // // // // // // //               label={t("Password")}
// // // // // // // // // // // // // //               type={showPassword ? "text" : "password"}
// // // // // // // // // // // // // //               inputRef={passwordRef}
// // // // // // // // // // // // // //               required
// // // // // // // // // // // // // //               error={!!errors.password}
// // // // // // // // // // // // // //               helperText={errors.password?.[0] || ""}
// // // // // // // // // // // // // //               InputProps={{
// // // // // // // // // // // // // //                 endAdornment: (
// // // // // // // // // // // // // //                   <InputAdornment position="end">
// // // // // // // // // // // // // //                     <IconButton onClick={() => setShowPassword(!showPassword)}>{showPassword ? <VisibilityOff /> : <Visibility />}</IconButton>
// // // // // // // // // // // // // //                   </InputAdornment>
// // // // // // // // // // // // // //                 ),
// // // // // // // // // // // // // //               }}
// // // // // // // // // // // // // //             />

// // // // // // // // // // // // // //             <Box>
// // // // // // // // // // // // // //                 <PhoneField phone={phone} setPhone={setPhone} />
// // // // // // // // // // // // // //                 {errors.phone_number && <Typography color="error" variant="caption">{errors.phone_number[0]}</Typography>}
// // // // // // // // // // // // // //             </Box>

// // // // // // // // // // // // // //             <TextField 
// // // // // // // // // // // // // //                 fullWidth 
// // // // // // // // // // // // // //                 label={t("ID CARD")} 
// // // // // // // // // // // // // //                 inputRef={idCardRef} 
// // // // // // // // // // // // // //                 error={!!errors.id_card}
// // // // // // // // // // // // // //                 helperText={errors.id_card?.[0] || ""}
// // // // // // // // // // // // // //             />

// // // // // // // // // // // // // //             <TextField fullWidth label={t("Date of Birth")} type="date" inputRef={dateRef} InputLabelProps={{ shrink: true }} />
            
// // // // // // // // // // // // // //             {/* ✅ Updated Alignment for Gender */}
// // // // // // // // // // // // // //             <FormControl fullWidth sx={{ alignItems: "flex-end" }}>
// // // // // // // // // // // // // //               <FormLabel sx={{ fontSize: "0.8rem", textAlign: "right", width: "100%" }}>
// // // // // // // // // // // // // //                 {t("GENDER (OPTIONAL)")}
// // // // // // // // // // // // // //               </FormLabel>
// // // // // // // // // // // // // //               <RadioGroup row value={gender} onChange={(e) => setGender(e.target.value)}>
// // // // // // // // // // // // // //                 <FormControlLabel value="M" control={<Radio size="small" />} label={t("MALE")} />
// // // // // // // // // // // // // //                 <FormControlLabel value="F" control={<Radio size="small" />} label={t("FEMALE")} />
// // // // // // // // // // // // // //               </RadioGroup>
// // // // // // // // // // // // // //             </FormControl>
// // // // // // // // // // // // // //           </Box>

// // // // // // // // // // // // // //           {role === "TECHNICIAN" && (
// // // // // // // // // // // // // //             <Box sx={{ mt: 3, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
// // // // // // // // // // // // // //               <TextField fullWidth label={t("Specializations")} inputRef={specializationsRef} sx={{ mb: 2 }} />
// // // // // // // // // // // // // //               <Typography variant="caption" sx={{ display: 'block', mb: 1 }}>{t("Calendar Color Selection")}</Typography>
// // // // // // // // // // // // // //               <SketchPicker color={color} onChangeComplete={(c) => setColor(c.hex)} />
// // // // // // // // // // // // // //             </Box>
// // // // // // // // // // // // // //           )}

// // // // // // // // // // // // // //           <Box mt={4} display="flex" gap={2}>
// // // // // // // // // // // // // //             <Button type="submit" variant="contained" size="large">{t("SUBMIT")}</Button>
// // // // // // // // // // // // // //             <Button type="button" variant="outlined" size="large" onClick={handleReset}>{t("RESET")}</Button>
// // // // // // // // // // // // // //           </Box>
// // // // // // // // // // // // // //         </form>
// // // // // // // // // // // // // //       </CardContent>
// // // // // // // // // // // // // //     </Card>
// // // // // // // // // // // // // //   );
// // // // // // // // // // // // // // };

// // // // // // // // // // // // // // export default UserForm;

// // // // // // // // // // // // // import GDPRPolicyLink from "../components/GDPRPolicyLink";
// // // // // // // // // // // // // import { useState, useRef } from "react";
// // // // // // // // // // // // // import {
// // // // // // // // // // // // //   Card,
// // // // // // // // // // // // //   CardContent,
// // // // // // // // // // // // //   Typography,
// // // // // // // // // // // // //   TextField,
// // // // // // // // // // // // //   Button,
// // // // // // // // // // // // //   Box,
// // // // // // // // // // // // //   FormLabel,
// // // // // // // // // // // // //   RadioGroup,
// // // // // // // // // // // // //   FormControlLabel,
// // // // // // // // // // // // //   Radio,
// // // // // // // // // // // // //   InputAdornment,
// // // // // // // // // // // // //   Checkbox,
// // // // // // // // // // // // //   Alert,
// // // // // // // // // // // // //   IconButton,
// // // // // // // // // // // // //   FormControl,
// // // // // // // // // // // // // } from "@mui/material";
// // // // // // // // // // // // // import { SketchPicker } from "react-color";
// // // // // // // // // // // // // import axiosClient from "../axiosClient";
// // // // // // // // // // // // // import { useTranslation } from "react-i18next";
// // // // // // // // // // // // // import PhoneField from "../components/PhoneField";
// // // // // // // // // // // // // import { Visibility, VisibilityOff } from "@mui/icons-material";

// // // // // // // // // // // // // const UserForm = () => {
// // // // // // // // // // // // //   const nameRef = useRef(null);
// // // // // // // // // // // // //   const surnameRef = useRef(null);
// // // // // // // // // // // // //   const dateRef = useRef(null);
// // // // // // // // // // // // //   const passwordRef = useRef(null);
// // // // // // // // // // // // //   const emailRef = useRef(null);
// // // // // // // // // // // // //   const idCardRef = useRef(null);
// // // // // // // // // // // // //   const cityRef = useRef(null);
// // // // // // // // // // // // //   const specializationsRef = useRef(null); 

// // // // // // // // // // // // //   const [gender, setGender] = useState("");
// // // // // // // // // // // // //   const [role, setRole] = useState("TECHNICIAN"); 
// // // // // // // // // // // // //   const [error, setError] = useState();
// // // // // // // // // // // // //   const [message, setMessage] = useState();
// // // // // // // // // // // // //   const [color, setColor] = useState("#3f51b5");
// // // // // // // // // // // // //   const [phone, setPhone] = useState("+357");
// // // // // // // // // // // // //   const [hardcopyConsent, setHardcopyConsent] = useState(false);
// // // // // // // // // // // // //   const [errors, setErrors] = useState({});
// // // // // // // // // // // // //   const { t } = useTranslation();
// // // // // // // // // // // // //   const [showPassword, setShowPassword] = useState(false);

// // // // // // // // // // // // //   const normalizePhone = (value) => {
// // // // // // // // // // // // //     if (!value) return "";
// // // // // // // // // // // // //     const trimmed = String(value).trim();
// // // // // // // // // // // // //     if (trimmed === "+357") return "";
// // // // // // // // // // // // //     return trimmed.startsWith("+") ? trimmed : `+${trimmed}`;
// // // // // // // // // // // // //   };

// // // // // // // // // // // // //   const handleSubmit = (event) => {
// // // // // // // // // // // // //     event.preventDefault();
// // // // // // // // // // // // //     setErrors({});
// // // // // // // // // // // // //     setError(undefined);
// // // // // // // // // // // // //     setMessage(undefined);

// // // // // // // // // // // // //     const emailVal = emailRef.current?.value || "";
// // // // // // // // // // // // //     const passwordVal = passwordRef.current?.value || "";
// // // // // // // // // // // // //     const phoneVal = normalizePhone(phone);

// // // // // // // // // // // // //     const localErrors = {};
// // // // // // // // // // // // //     if (!emailVal.includes("@")) localErrors.email = t("Invalid email");
// // // // // // // // // // // // //     if (passwordVal.length < 8) localErrors.password = t("Min 8 characters");
// // // // // // // // // // // // //     if (!phoneVal) localErrors.phone_number = t("Phone is required");

// // // // // // // // // // // // //     if (Object.keys(localErrors).length) {
// // // // // // // // // // // // //       setErrors(localErrors);
// // // // // // // // // // // // //       return;
// // // // // // // // // // // // //     }

// // // // // // // // // // // // //     const payload = {
// // // // // // // // // // // // //       user_role: role, 
// // // // // // // // // // // // //       username: emailVal,
// // // // // // // // // // // // //       email: emailVal,
// // // // // // // // // // // // //       password: passwordVal,
// // // // // // // // // // // // //       first_name: nameRef.current?.value || "",
// // // // // // // // // // // // //       last_name: surnameRef.current?.value || "",
// // // // // // // // // // // // //       phone_number: phoneVal,
// // // // // // // // // // // // //       gender: gender || null,
// // // // // // // // // // // // //       date_birth: dateRef.current?.value || null,
// // // // // // // // // // // // //       id_card: idCardRef.current?.value || "",
// // // // // // // // // // // // //       city: cityRef.current?.value || "",
// // // // // // // // // // // // //       hardcopy_consent: hardcopyConsent,
// // // // // // // // // // // // //       ...(role === "TECHNICIAN" ? { color: color, specializations: specializationsRef.current?.value || "" } : {})
// // // // // // // // // // // // //     };

// // // // // // // // // // // // //     axiosClient
// // // // // // // // // // // // //       .post("auth/users/", payload) 
// // // // // // // // // // // // //       .then(() => {
// // // // // // // // // // // // //         setMessage(t("User added successfully"));
// // // // // // // // // // // // //         handleReset();
// // // // // // // // // // // // //       })
// // // // // // // // // // // // //       .catch((err) => {
// // // // // // // // // // // // //         const backendErrors = err.response?.data;
// // // // // // // // // // // // //         if (backendErrors && typeof backendErrors === 'object') {
// // // // // // // // // // // // //           const firstErrorKey = Object.keys(backendErrors)[0];
// // // // // // // // // // // // //           const firstErrorMsg = Array.isArray(backendErrors[firstErrorKey]) 
// // // // // // // // // // // // //             ? backendErrors[firstErrorKey][0] 
// // // // // // // // // // // // //             : backendErrors[firstErrorKey];
          
// // // // // // // // // // // // //           setError(`${firstErrorKey}: ${firstErrorMsg}`);
// // // // // // // // // // // // //           setErrors(backendErrors);
// // // // // // // // // // // // //         } else {
// // // // // // // // // // // // //           setError(t("Failed to create user. Check if email or ID Card is unique."));
// // // // // // // // // // // // //         }
// // // // // // // // // // // // //       });
// // // // // // // // // // // // //   };

// // // // // // // // // // // // //   const handleReset = () => {
// // // // // // // // // // // // //     setRole("TECHNICIAN");
// // // // // // // // // // // // //     setGender("");
// // // // // // // // // // // // //     setPhone("+357");
// // // // // // // // // // // // //     setHardcopyConsent(false);
// // // // // // // // // // // // //     setErrors({});
// // // // // // // // // // // // //     [nameRef, surnameRef, dateRef, passwordRef, emailRef, idCardRef, cityRef, specializationsRef].forEach(ref => {
// // // // // // // // // // // // //       if (ref.current) ref.current.value = "";
// // // // // // // // // // // // //     });
// // // // // // // // // // // // //   };

// // // // // // // // // // // // //   return (
// // // // // // // // // // // // //     <Card elevation={16}>
// // // // // // // // // // // // //       <CardContent>
// // // // // // // // // // // // //         <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>{t("Create New User")}</Typography>
        
// // // // // // // // // // // // //         {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // // // // // // // // // // // //         {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// // // // // // // // // // // // //         <form onSubmit={handleSubmit}>
// // // // // // // // // // // // //           <Box display="flex" alignItems="center" sx={{ mb: 3 }}>
// // // // // // // // // // // // //             <FormLabel sx={{ mr: 2, fontWeight: 'bold' }}>{t("Role")}</FormLabel>
// // // // // // // // // // // // //             <RadioGroup row value={role} onChange={(e) => setRole(e.target.value)}>
// // // // // // // // // // // // //               <FormControlLabel value="RECEPTION" control={<Radio />} label={t("Reception")} />
// // // // // // // // // // // // //               <FormControlLabel value="ADMIN" control={<Radio />} label={t("Admin")} />
// // // // // // // // // // // // //               <FormControlLabel value="TECHNICIAN" control={<Radio />} label={t("Technician")} />
// // // // // // // // // // // // //               <FormControlLabel value="MAID" control={<Radio />} label={t("Maid")} />
// // // // // // // // // // // // //             </RadioGroup>
// // // // // // // // // // // // //           </Box>

// // // // // // // // // // // // //           <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
// // // // // // // // // // // // //             <TextField fullWidth label={t("Name")} inputRef={nameRef} required />
// // // // // // // // // // // // //             <TextField fullWidth label={t("Surname")} inputRef={surnameRef} required />
            
// // // // // // // // // // // // //             <TextField 
// // // // // // // // // // // // //                 fullWidth 
// // // // // // // // // // // // //                 label={t("Email")} 
// // // // // // // // // // // // //                 type="email" 
// // // // // // // // // // // // //                 inputRef={emailRef} 
// // // // // // // // // // // // //                 required 
// // // // // // // // // // // // //                 error={!!errors.email} 
// // // // // // // // // // // // //                 helperText={errors.email?.[0] || ""}
// // // // // // // // // // // // //             />
            
// // // // // // // // // // // // //             <TextField
// // // // // // // // // // // // //               fullWidth
// // // // // // // // // // // // //               label={t("Password")}
// // // // // // // // // // // // //               type={showPassword ? "text" : "password"}
// // // // // // // // // // // // //               inputRef={passwordRef}
// // // // // // // // // // // // //               required
// // // // // // // // // // // // //               error={!!errors.password}
// // // // // // // // // // // // //               helperText={errors.password?.[0] || ""}
// // // // // // // // // // // // //               InputProps={{
// // // // // // // // // // // // //                 endAdornment: (
// // // // // // // // // // // // //                   <InputAdornment position="end">
// // // // // // // // // // // // //                     <IconButton onClick={() => setShowPassword(!showPassword)}>{showPassword ? <VisibilityOff /> : <Visibility />}</IconButton>
// // // // // // // // // // // // //                   </InputAdornment>
// // // // // // // // // // // // //                 ),
// // // // // // // // // // // // //               }}
// // // // // // // // // // // // //             />

// // // // // // // // // // // // //             <Box>
// // // // // // // // // // // // //                 <PhoneField phone={phone} setPhone={setPhone} />
// // // // // // // // // // // // //                 {errors.phone_number && <Typography color="error" variant="caption">{errors.phone_number[0]}</Typography>}
// // // // // // // // // // // // //             </Box>

// // // // // // // // // // // // //             <TextField 
// // // // // // // // // // // // //                 fullWidth 
// // // // // // // // // // // // //                 label={t("ID CARD")} 
// // // // // // // // // // // // //                 inputRef={idCardRef} 
// // // // // // // // // // // // //                 error={!!errors.id_card}
// // // // // // // // // // // // //                 helperText={errors.id_card?.[0] || ""}
// // // // // // // // // // // // //             />

// // // // // // // // // // // // //             <TextField fullWidth label={t("Date of Birth")} type="date" inputRef={dateRef} InputLabelProps={{ shrink: true }} />
            
// // // // // // // // // // // // //             {/* ✅ Centered Gender Section */}
// // // // // // // // // // // // //             <FormControl fullWidth sx={{ alignItems: "center" }}>
// // // // // // // // // // // // //               <FormLabel sx={{ fontSize: "0.8rem", textAlign: "center", width: "100%" }}>
// // // // // // // // // // // // //                 {t("GENDER (OPTIONAL)")}
// // // // // // // // // // // // //               </FormLabel>
// // // // // // // // // // // // //               <RadioGroup 
// // // // // // // // // // // // //                 row 
// // // // // // // // // // // // //                 value={gender} 
// // // // // // // // // // // // //                 onChange={(e) => setGender(e.target.value)}
// // // // // // // // // // // // //                 sx={{ justifyContent: "center" }}
// // // // // // // // // // // // //               >
// // // // // // // // // // // // //                 <FormControlLabel value="M" control={<Radio size="small" />} label={t("MALE")} />
// // // // // // // // // // // // //                 <FormControlLabel value="F" control={<Radio size="small" />} label={t("FEMALE")} />
// // // // // // // // // // // // //               </RadioGroup>
// // // // // // // // // // // // //             </FormControl>
// // // // // // // // // // // // //           </Box>

// // // // // // // // // // // // //           {role === "TECHNICIAN" && (
// // // // // // // // // // // // //             <Box sx={{ mt: 3, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
// // // // // // // // // // // // //               <TextField fullWidth label={t("Specializations")} inputRef={specializationsRef} sx={{ mb: 2 }} />
// // // // // // // // // // // // //               <Typography variant="caption" sx={{ display: 'block', mb: 1 }}>{t("Calendar Color Selection")}</Typography>
// // // // // // // // // // // // //               <SketchPicker color={color} onChangeComplete={(c) => setColor(c.hex)} />
// // // // // // // // // // // // //             </Box>
// // // // // // // // // // // // //           )}

// // // // // // // // // // // // //           <Box mt={4} display="flex" gap={2}>
// // // // // // // // // // // // //             <Button type="submit" variant="contained" size="large">{t("SUBMIT")}</Button>
// // // // // // // // // // // // //             <Button type="button" variant="outlined" size="large" onClick={handleReset}>{t("RESET")}</Button>
// // // // // // // // // // // // //           </Box>
// // // // // // // // // // // // //         </form>
// // // // // // // // // // // // //       </CardContent>
// // // // // // // // // // // // //     </Card>
// // // // // // // // // // // // //   );
// // // // // // // // // // // // // };

// // // // // // // // // // // // // export default UserForm;


// // // // // // // // // // // import GDPRPolicyLink from "../components/GDPRPolicyLink";
// // // // // // // // // // // import { useState, useRef } from "react";
// // // // // // // // // // // import {
// // // // // // // // // // //   Card,
// // // // // // // // // // //   CardContent,
// // // // // // // // // // //   Typography,
// // // // // // // // // // //   TextField,
// // // // // // // // // // //   Button,
// // // // // // // // // // //   Box,
// // // // // // // // // // //   FormLabel,
// // // // // // // // // // //   RadioGroup,
// // // // // // // // // // //   FormControlLabel,
// // // // // // // // // // //   Radio,
// // // // // // // // // // //   InputAdornment,
// // // // // // // // // // //   Checkbox,
// // // // // // // // // // //   Alert,
// // // // // // // // // // //   IconButton,
// // // // // // // // // // //   FormControl,
// // // // // // // // // // // } from "@mui/material";
// // // // // // // // // // // import { SketchPicker } from "react-color";
// // // // // // // // // // // import axiosClient from "../axiosClient";
// // // // // // // // // // // import { useTranslation } from "react-i18next";
// // // // // // // // // // // import PhoneField from "../components/PhoneField";
// // // // // // // // // // // import { Visibility, VisibilityOff } from "@mui/icons-material";

// // // // // // // // // // // const UserForm = () => {
// // // // // // // // // // //   const nameRef = useRef(null);
// // // // // // // // // // //   const surnameRef = useRef(null);
// // // // // // // // // // //   const dateRef = useRef(null);
// // // // // // // // // // //   const passwordRef = useRef(null);
// // // // // // // // // // //   const emailRef = useRef(null);
// // // // // // // // // // //   const idCardRef = useRef(null);
// // // // // // // // // // //   const cityRef = useRef(null);
// // // // // // // // // // //   const specializationsRef = useRef(null); 

// // // // // // // // // // //   const [gender, setGender] = useState("");
// // // // // // // // // // //   const [role, setRole] = useState("TECHNICIAN"); 
// // // // // // // // // // //   const [error, setError] = useState();
// // // // // // // // // // //   const [message, setMessage] = useState();
// // // // // // // // // // //   const [color, setColor] = useState("#3f51b5");
// // // // // // // // // // //   const [phone, setPhone] = useState("+357");
// // // // // // // // // // //   const [hardcopyConsent, setHardcopyConsent] = useState(false);
// // // // // // // // // // //   const [errors, setErrors] = useState({});
// // // // // // // // // // //   const { t } = useTranslation();
// // // // // // // // // // //   const [showPassword, setShowPassword] = useState(false);

// // // // // // // // // // //   const normalizePhone = (value) => {
// // // // // // // // // // //     if (!value) return "";
// // // // // // // // // // //     const trimmed = String(value).trim();
// // // // // // // // // // //     if (trimmed === "+357") return "";
// // // // // // // // // // //     return trimmed.startsWith("+") ? trimmed : `+${trimmed}`;
// // // // // // // // // // //   };

// // // // // // // // // // //   const handleSubmit = (event) => {
// // // // // // // // // // //     event.preventDefault();
// // // // // // // // // // //     setErrors({});
// // // // // // // // // // //     setError(undefined);
// // // // // // // // // // //     setMessage(undefined);

// // // // // // // // // // //     const emailVal = emailRef.current?.value || "";
// // // // // // // // // // //     const passwordVal = passwordRef.current?.value || "";
// // // // // // // // // // //     const phoneVal = normalizePhone(phone);

// // // // // // // // // // //     // Updated Validation: specifically checking for empty email
// // // // // // // // // // //     const localErrors = {};
// // // // // // // // // // //     if (!emailVal) {
// // // // // // // // // // //       localErrors.email = t("Email is required");
// // // // // // // // // // //     } else if (!emailVal.includes("@")) {
// // // // // // // // // // //       localErrors.email = t("Invalid email");
// // // // // // // // // // //     }
    
// // // // // // // // // // //     if (passwordVal.length < 8) localErrors.password = t("Min 8 characters");
// // // // // // // // // // //     if (!phoneVal) localErrors.phone_number = t("Phone is required");

// // // // // // // // // // //     if (Object.keys(localErrors).length) {
// // // // // // // // // // //       setErrors(localErrors);
// // // // // // // // // // //       return;
// // // // // // // // // // //     }

// // // // // // // // // // //     const payload = {
// // // // // // // // // // //       user_role: role, 
// // // // // // // // // // //       username: emailVal,
// // // // // // // // // // //       email: emailVal,
// // // // // // // // // // //       password: passwordVal,
// // // // // // // // // // //       first_name: nameRef.current?.value || "",
// // // // // // // // // // //       last_name: surnameRef.current?.value || "",
// // // // // // // // // // //       phone_number: phoneVal,
// // // // // // // // // // //       gender: gender || null,
// // // // // // // // // // //       date_birth: dateRef.current?.value || null,
// // // // // // // // // // //       id_card: idCardRef.current?.value || "",
// // // // // // // // // // //       city: cityRef.current?.value || "",
// // // // // // // // // // //       hardcopy_consent: hardcopyConsent,
// // // // // // // // // // //       ...(role === "TECHNICIAN" ? { color: color, specializations: specializationsRef.current?.value || "" } : {})
// // // // // // // // // // //     };

// // // // // // // // // // //     axiosClient
// // // // // // // // // // //       .post("auth/users/", payload) 
// // // // // // // // // // //       .then(() => {
// // // // // // // // // // //         setMessage(t("User added successfully"));
// // // // // // // // // // //         handleReset();
// // // // // // // // // // //       })
// // // // // // // // // // //       .catch((err) => {
// // // // // // // // // // //         const backendErrors = err.response?.data;
// // // // // // // // // // //         if (backendErrors && typeof backendErrors === 'object') {
// // // // // // // // // // //           const firstErrorKey = Object.keys(backendErrors)[0];
// // // // // // // // // // //           const firstErrorMsg = Array.isArray(backendErrors[firstErrorKey]) 
// // // // // // // // // // //             ? backendErrors[firstErrorKey][0] 
// // // // // // // // // // //             : backendErrors[firstErrorKey];
          
// // // // // // // // // // //           setError(`${firstErrorKey}: ${firstErrorMsg}`);
// // // // // // // // // // //           setErrors(backendErrors);
// // // // // // // // // // //         } else {
// // // // // // // // // // //           setError(t("Failed to create user. Check if email or ID Card is unique."));
// // // // // // // // // // //         }
// // // // // // // // // // //       });
// // // // // // // // // // //   };

// // // // // // // // // // //   const handleReset = () => {
// // // // // // // // // // //     setRole("TECHNICIAN");
// // // // // // // // // // //     setGender("");
// // // // // // // // // // //     setPhone("+357");
// // // // // // // // // // //     setHardcopyConsent(false);
// // // // // // // // // // //     setErrors({});
// // // // // // // // // // //     [nameRef, surnameRef, dateRef, passwordRef, emailRef, idCardRef, cityRef, specializationsRef].forEach(ref => {
// // // // // // // // // // //       if (ref.current) ref.current.value = "";
// // // // // // // // // // //     });
// // // // // // // // // // //   };

// // // // // // // // // // //   return (
// // // // // // // // // // //     <Card elevation={16}>
// // // // // // // // // // //       <CardContent>
// // // // // // // // // // //         <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>{t("Create New User")}</Typography>
        
// // // // // // // // // // //         {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // // // // // // // // // //         {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// // // // // // // // // // //         <form onSubmit={handleSubmit}>
// // // // // // // // // // //           <Box display="flex" alignItems="center" sx={{ mb: 3 }}>
// // // // // // // // // // //             <FormLabel sx={{ mr: 2, fontWeight: 'bold' }}>{t("Role")}</FormLabel>
// // // // // // // // // // //             <RadioGroup row value={role} onChange={(e) => setRole(e.target.value)}>
// // // // // // // // // // //               {/* Secretary replaced with Reception; added Admin and Maid */}
// // // // // // // // // // //               <FormControlLabel value="RECEPTION" control={<Radio />} label={t("Reception")} />
// // // // // // // // // // //               <FormControlLabel value="ADMIN" control={<Radio />} label={t("Admin")} />
// // // // // // // // // // //               <FormControlLabel value="TECHNICIAN" control={<Radio />} label={t("Technician")} />
// // // // // // // // // // //               <FormControlLabel value="MAID" control={<Radio />} label={t("Maid")} />
// // // // // // // // // // //             </RadioGroup>
// // // // // // // // // // //           </Box>

// // // // // // // // // // //           <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
// // // // // // // // // // //             <TextField fullWidth label={t("Name")} inputRef={nameRef} required />
// // // // // // // // // // //             <TextField fullWidth label={t("Surname")} inputRef={surnameRef} required />
            
// // // // // // // // // // //             <TextField 
// // // // // // // // // // //                 fullWidth 
// // // // // // // // // // //                 label={t("Email")} 
// // // // // // // // // // //                 type="email" 
// // // // // // // // // // //                 inputRef={emailRef} 
// // // // // // // // // // //                 required 
// // // // // // // // // // //                 error={!!errors.email} 
// // // // // // // // // // //                 helperText={errors.email || ""} // Error message appears if empty
// // // // // // // // // // //             />
            
// // // // // // // // // // //             <TextField
// // // // // // // // // // //               fullWidth
// // // // // // // // // // //               label={t("Password")}
// // // // // // // // // // //               type={showPassword ? "text" : "password"}
// // // // // // // // // // //               inputRef={passwordRef}
// // // // // // // // // // //               required
// // // // // // // // // // //               error={!!errors.password}
// // // // // // // // // // //               helperText={errors.password?.[0] || ""}
// // // // // // // // // // //               InputProps={{
// // // // // // // // // // //                 endAdornment: (
// // // // // // // // // // //                   <InputAdornment position="end">
// // // // // // // // // // //                     <IconButton onClick={() => setShowPassword(!showPassword)}>{showPassword ? <VisibilityOff /> : <Visibility />}</IconButton>
// // // // // // // // // // //                   </InputAdornment>
// // // // // // // // // // //                 ),
// // // // // // // // // // //               }}
// // // // // // // // // // //             />

// // // // // // // // // // //             <Box>
// // // // // // // // // // //                 <PhoneField phone={phone} setPhone={setPhone} />
// // // // // // // // // // //                 {errors.phone_number && <Typography color="error" variant="caption">{errors.phone_number[0]}</Typography>}
// // // // // // // // // // //             </Box>

// // // // // // // // // // //             <TextField 
// // // // // // // // // // //                 fullWidth 
// // // // // // // // // // //                 label={t("ID CARD")} 
// // // // // // // // // // //                 inputRef={idCardRef} 
// // // // // // // // // // //                 error={!!errors.id_card}
// // // // // // // // // // //                 helperText={errors.id_card?.[0] || ""}
// // // // // // // // // // //             />

// // // // // // // // // // //             <TextField fullWidth label={t("Date of Birth")} type="date" inputRef={dateRef} InputLabelProps={{ shrink: true }} />
            
// // // // // // // // // // //             {/* Centered Gender Options */}
// // // // // // // // // // //             <FormControl fullWidth sx={{ alignItems: "center" }}>
// // // // // // // // // // //               <FormLabel sx={{ fontSize: "0.8rem", textAlign: "center", width: "100%" }}>
// // // // // // // // // // //                 {t("GENDER (OPTIONAL)")}
// // // // // // // // // // //               </FormLabel>
// // // // // // // // // // //               <RadioGroup 
// // // // // // // // // // //                 row 
// // // // // // // // // // //                 value={gender} 
// // // // // // // // // // //                 onChange={(e) => setGender(e.target.value)}
// // // // // // // // // // //                 sx={{ justifyContent: "center" }}
// // // // // // // // // // //               >
// // // // // // // // // // //                 <FormControlLabel value="M" control={<Radio size="small" />} label={t("MALE")} />
// // // // // // // // // // //                 <FormControlLabel value="F" control={<Radio size="small" />} label={t("FEMALE")} />
// // // // // // // // // // //               </RadioGroup>
// // // // // // // // // // //             </FormControl>
// // // // // // // // // // //           </Box>

// // // // // // // // // // //           {role === "TECHNICIAN" && (
// // // // // // // // // // //             <Box sx={{ mt: 3, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
// // // // // // // // // // //               <TextField fullWidth label={t("Specializations")} inputRef={specializationsRef} sx={{ mb: 2 }} />
// // // // // // // // // // //               <Typography variant="caption" sx={{ display: 'block', mb: 1 }}>{t("Calendar Color Selection")}</Typography>
// // // // // // // // // // //               <SketchPicker color={color} onChangeComplete={(c) => setColor(c.hex)} />
// // // // // // // // // // //             </Box>
// // // // // // // // // // //           )}

// // // // // // // // // // //           <Box mt={4} display="flex" gap={2}>
// // // // // // // // // // //             <Button type="submit" variant="contained" size="large">{t("SUBMIT")}</Button>
// // // // // // // // // // //             <Button type="button" variant="outlined" size="large" onClick={handleReset}>{t("RESET")}</Button>
// // // // // // // // // // //           </Box>
// // // // // // // // // // //         </form>
// // // // // // // // // // //       </CardContent>
// // // // // // // // // // //     </Card>
// // // // // // // // // // //   );
// // // // // // // // // // // };

// // // // // // // // // // // export default UserForm;


// // // // // // // // // // import GDPRPolicyLink from "../components/GDPRPolicyLink";
// // // // // // // // // // import { useState, useRef } from "react";
// // // // // // // // // // import {
// // // // // // // // // //   Card,
// // // // // // // // // //   CardContent,
// // // // // // // // // //   Typography,
// // // // // // // // // //   TextField,
// // // // // // // // // //   Button,
// // // // // // // // // //   Box,
// // // // // // // // // //   FormLabel,
// // // // // // // // // //   RadioGroup,
// // // // // // // // // //   FormControlLabel,
// // // // // // // // // //   Radio,
// // // // // // // // // //   InputAdornment,
// // // // // // // // // //   Checkbox,
// // // // // // // // // //   Alert,
// // // // // // // // // //   IconButton,
// // // // // // // // // //   FormControl,
// // // // // // // // // // } from "@mui/material";
// // // // // // // // // // import { SketchPicker } from "react-color";
// // // // // // // // // // import axiosClient from "../axiosClient";
// // // // // // // // // // import { useTranslation } from "react-i18next";
// // // // // // // // // // import PhoneField from "../components/PhoneField";
// // // // // // // // // // import { Visibility, VisibilityOff } from "@mui/icons-material";

// // // // // // // // // // const UserForm = () => {
// // // // // // // // // //   const nameRef = useRef(null);
// // // // // // // // // //   const surnameRef = useRef(null);
// // // // // // // // // //   const dateRef = useRef(null);
// // // // // // // // // //   const passwordRef = useRef(null);
// // // // // // // // // //   const emailRef = useRef(null);
// // // // // // // // // //   const idCardRef = useRef(null);
// // // // // // // // // //   const cityRef = useRef(null);
// // // // // // // // // //   const specializationsRef = useRef(null); 

// // // // // // // // // //   const [gender, setGender] = useState("");
// // // // // // // // // //   const [role, setRole] = useState("TECHNICIAN"); 
// // // // // // // // // //   const [error, setError] = useState();
// // // // // // // // // //   const [message, setMessage] = useState();
// // // // // // // // // //   const [color, setColor] = useState("#3f51b5");
// // // // // // // // // //   const [phone, setPhone] = useState("+357");
// // // // // // // // // //   const [hardcopyConsent, setHardcopyConsent] = useState(false);
// // // // // // // // // //   const [errors, setErrors] = useState({});
// // // // // // // // // //   const { t } = useTranslation();
// // // // // // // // // //   const [showPassword, setShowPassword] = useState(false);

// // // // // // // // // //   const normalizePhone = (value) => {
// // // // // // // // // //     if (!value) return "";
// // // // // // // // // //     const trimmed = String(value).trim();
// // // // // // // // // //     if (trimmed === "+357") return "";
// // // // // // // // // //     return trimmed.startsWith("+") ? trimmed : `+${trimmed}`;
// // // // // // // // // //   };

// // // // // // // // // //   const handleSubmit = (event) => {
// // // // // // // // // //     event.preventDefault();
// // // // // // // // // //     setErrors({});
// // // // // // // // // //     setError(undefined);
// // // // // // // // // //     setMessage(undefined);

// // // // // // // // // //     const emailVal = emailRef.current?.value || "";
// // // // // // // // // //     const passwordVal = passwordRef.current?.value || "";
// // // // // // // // // //     const phoneVal = normalizePhone(phone);

// // // // // // // // // //     const localErrors = {};
// // // // // // // // // //     if (!emailVal) {
// // // // // // // // // //       localErrors.email = t("Email is required");
// // // // // // // // // //     } else if (!emailVal.includes("@")) {
// // // // // // // // // //       localErrors.email = t("Invalid email");
// // // // // // // // // //     }
    
// // // // // // // // // //     if (passwordVal.length < 8) localErrors.password = t("Min 8 characters");
// // // // // // // // // //     if (!phoneVal) localErrors.phone_number = t("Phone is required");

// // // // // // // // // //     if (Object.keys(localErrors).length) {
// // // // // // // // // //       setErrors(localErrors);
// // // // // // // // // //       return;
// // // // // // // // // //     }

// // // // // // // // // //     // UPDATED: Include color and specializations for both TECHNICIAN and MAID
// // // // // // // // // //     const payload = {
// // // // // // // // // //       user_role: role, 
// // // // // // // // // //       username: emailVal,
// // // // // // // // // //       email: emailVal,
// // // // // // // // // //       password: passwordVal,
// // // // // // // // // //       first_name: nameRef.current?.value || "",
// // // // // // // // // //       last_name: surnameRef.current?.value || "",
// // // // // // // // // //       phone_number: phoneVal,
// // // // // // // // // //       gender: gender || null,
// // // // // // // // // //       date_birth: dateRef.current?.value || null,
// // // // // // // // // //       id_card: idCardRef.current?.value || "",
// // // // // // // // // //       city: cityRef.current?.value || "",
// // // // // // // // // //       hardcopy_consent: hardcopyConsent,
// // // // // // // // // //       ...((role === "TECHNICIAN" || role === "MAID") 
// // // // // // // // // //           ? { color: color, specializations: specializationsRef.current?.value || "" } 
// // // // // // // // // //           : {})
// // // // // // // // // //     };

// // // // // // // // // //     axiosClient
// // // // // // // // // //       .post("auth/users/", payload) 
// // // // // // // // // //       .then(() => {
// // // // // // // // // //         setMessage(t("User added successfully"));
// // // // // // // // // //         handleReset();
// // // // // // // // // //       })
// // // // // // // // // //       .catch((err) => {
// // // // // // // // // //         const backendErrors = err.response?.data;
// // // // // // // // // //         if (backendErrors && typeof backendErrors === 'object') {
// // // // // // // // // //           const firstErrorKey = Object.keys(backendErrors)[0];
// // // // // // // // // //           const firstErrorMsg = Array.isArray(backendErrors[firstErrorKey]) 
// // // // // // // // // //             ? backendErrors[firstErrorKey][0] 
// // // // // // // // // //             : backendErrors[firstErrorKey];
          
// // // // // // // // // //           setError(`${firstErrorKey}: ${firstErrorMsg}`);
// // // // // // // // // //           setErrors(backendErrors);
// // // // // // // // // //         } else {
// // // // // // // // // //           setError(t("Failed to create user. Check if email or ID Card is unique."));
// // // // // // // // // //         }
// // // // // // // // // //       });
// // // // // // // // // //   };

// // // // // // // // // //   const handleReset = () => {
// // // // // // // // // //     setRole("TECHNICIAN");
// // // // // // // // // //     setGender("");
// // // // // // // // // //     setPhone("+357");
// // // // // // // // // //     setHardcopyConsent(false);
// // // // // // // // // //     setErrors({});
// // // // // // // // // //     [nameRef, surnameRef, dateRef, passwordRef, emailRef, idCardRef, cityRef, specializationsRef].forEach(ref => {
// // // // // // // // // //       if (ref.current) ref.current.value = "";
// // // // // // // // // //     });
// // // // // // // // // //   };

// // // // // // // // // //   return (
// // // // // // // // // //     <Card elevation={16}>
// // // // // // // // // //       <CardContent>
// // // // // // // // // //         <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>{t("Create New User")}</Typography>
        
// // // // // // // // // //         {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // // // // // // // // //         {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// // // // // // // // // //         <form onSubmit={handleSubmit}>
// // // // // // // // // //           <Box display="flex" alignItems="center" sx={{ mb: 3 }}>
// // // // // // // // // //             <FormLabel sx={{ mr: 2, fontWeight: 'bold' }}>{t("Role")}</FormLabel>
// // // // // // // // // //             <RadioGroup row value={role} onChange={(e) => setRole(e.target.value)}>
// // // // // // // // // //               <FormControlLabel value="RECEPTION" control={<Radio />} label={t("Reception")} />
// // // // // // // // // //               <FormControlLabel value="ADMIN" control={<Radio />} label={t("Admin")} />
// // // // // // // // // //               <FormControlLabel value="TECHNICIAN" control={<Radio />} label={t("Technician")} />
// // // // // // // // // //               <FormControlLabel value="MAID" control={<Radio />} label={t("Maid")} />
// // // // // // // // // //             </RadioGroup>
// // // // // // // // // //           </Box>

// // // // // // // // // //           <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
// // // // // // // // // //             <TextField fullWidth label={t("Name")} inputRef={nameRef} required />
// // // // // // // // // //             <TextField fullWidth label={t("Surname")} inputRef={surnameRef} required />
            
// // // // // // // // // //             <TextField 
// // // // // // // // // //                 fullWidth 
// // // // // // // // // //                 label={t("Email")} 
// // // // // // // // // //                 type="email" 
// // // // // // // // // //                 inputRef={emailRef} 
// // // // // // // // // //                 required 
// // // // // // // // // //                 error={!!errors.email} 
// // // // // // // // // //                 helperText={errors.email || ""} 
// // // // // // // // // //             />
            
// // // // // // // // // //             <TextField
// // // // // // // // // //               fullWidth
// // // // // // // // // //               label={t("Password")}
// // // // // // // // // //               type={showPassword ? "text" : "password"}
// // // // // // // // // //               inputRef={passwordRef}
// // // // // // // // // //               required
// // // // // // // // // //               error={!!errors.password}
// // // // // // // // // //               helperText={errors.password?.[0] || ""}
// // // // // // // // // //               InputProps={{
// // // // // // // // // //                 endAdornment: (
// // // // // // // // // //                   <InputAdornment position="end">
// // // // // // // // // //                     <IconButton onClick={() => setShowPassword(!showPassword)}>{showPassword ? <VisibilityOff /> : <Visibility />}</IconButton>
// // // // // // // // // //                   </InputAdornment>
// // // // // // // // // //                 ),
// // // // // // // // // //               }}
// // // // // // // // // //             />

// // // // // // // // // //             <Box>
// // // // // // // // // //                 <PhoneField phone={phone} setPhone={setPhone} />
// // // // // // // // // //                 {errors.phone_number && <Typography color="error" variant="caption">{errors.phone_number[0]}</Typography>}
// // // // // // // // // //             </Box>

// // // // // // // // // //             <TextField 
// // // // // // // // // //                 fullWidth 
// // // // // // // // // //                 label={t("ID CARD")} 
// // // // // // // // // //                 inputRef={idCardRef} 
// // // // // // // // // //                 error={!!errors.id_card}
// // // // // // // // // //                 helperText={errors.id_card?.[0] || ""}
// // // // // // // // // //             />

// // // // // // // // // //             <TextField fullWidth label={t("Date of Birth")} type="date" inputRef={dateRef} InputLabelProps={{ shrink: true }} />
            
// // // // // // // // // //             <FormControl fullWidth sx={{ alignItems: "center" }}>
// // // // // // // // // //               <FormLabel sx={{ fontSize: "0.8rem", textAlign: "center", width: "100%" }}>
// // // // // // // // // //                 {t("GENDER (OPTIONAL)")}
// // // // // // // // // //               </FormLabel>
// // // // // // // // // //               <RadioGroup 
// // // // // // // // // //                 row 
// // // // // // // // // //                 value={gender} 
// // // // // // // // // //                 onChange={(e) => setGender(e.target.value)}
// // // // // // // // // //                 sx={{ justifyContent: "center" }}
// // // // // // // // // //               >
// // // // // // // // // //                 <FormControlLabel value="M" control={<Radio size="small" />} label={t("MALE")} />
// // // // // // // // // //                 <FormControlLabel value="F" control={<Radio size="small" />} label={t("FEMALE")} />
// // // // // // // // // //               </RadioGroup>
// // // // // // // // // //             </FormControl>
// // // // // // // // // //           </Box>

// // // // // // // // // //           {/* UPDATED: Condition now includes both TECHNICIAN and MAID */}
// // // // // // // // // //           {(role === "TECHNICIAN" || role === "MAID") && (
// // // // // // // // // //             <Box sx={{ mt: 3, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
// // // // // // // // // //               <TextField 
// // // // // // // // // //                 fullWidth 
// // // // // // // // // //                 label={t("Specializations")} 
// // // // // // // // // //                 inputRef={specializationsRef} 
// // // // // // // // // //                 sx={{ mb: 2 }} 
// // // // // // // // // //               />
// // // // // // // // // //               <Typography variant="caption" sx={{ display: 'block', mb: 1 }}>
// // // // // // // // // //                 {t("Calendar Color Selection")}
// // // // // // // // // //               </Typography>
// // // // // // // // // //               <SketchPicker color={color} onChangeComplete={(c) => setColor(c.hex)} />
// // // // // // // // // //             </Box>
// // // // // // // // // //           )}

// // // // // // // // // //           <Box mt={4} display="flex" gap={2}>
// // // // // // // // // //             <Button type="submit" variant="contained" size="large">{t("SUBMIT")}</Button>
// // // // // // // // // //             <Button type="button" variant="outlined" size="large" onClick={handleReset}>{t("RESET")}</Button>
// // // // // // // // // //           </Box>
// // // // // // // // // //         </form>
// // // // // // // // // //       </CardContent>
// // // // // // // // // //     </Card>
// // // // // // // // // //   );
// // // // // // // // // // };

// // // // // // // // // // export default UserForm;

// // // // // // // // // import GDPRPolicyLink from "../components/GDPRPolicyLink";
// // // // // // // // // import { useState, useRef } from "react";
// // // // // // // // // import {
// // // // // // // // //   Card,
// // // // // // // // //   CardContent,
// // // // // // // // //   Typography,
// // // // // // // // //   TextField,
// // // // // // // // //   Button,
// // // // // // // // //   Box,
// // // // // // // // //   FormLabel,
// // // // // // // // //   RadioGroup,
// // // // // // // // //   FormControlLabel,
// // // // // // // // //   Radio,
// // // // // // // // //   InputAdornment,
// // // // // // // // //   Checkbox,
// // // // // // // // //   Alert,
// // // // // // // // //   IconButton,
// // // // // // // // //   FormControl,
// // // // // // // // // } from "@mui/material";
// // // // // // // // // import { SketchPicker } from "react-color";
// // // // // // // // // import axiosClient from "../axiosClient";
// // // // // // // // // import { useTranslation } from "react-i18next";
// // // // // // // // // import PhoneField from "../components/PhoneField";
// // // // // // // // // import { Visibility, VisibilityOff } from "@mui/icons-material";

// // // // // // // // // const UserForm = () => {
// // // // // // // // //   const nameRef = useRef(null);
// // // // // // // // //   const surnameRef = useRef(null);
// // // // // // // // //   const dateRef = useRef(null);
// // // // // // // // //   const passwordRef = useRef(null);
// // // // // // // // //   const emailRef = useRef(null);
// // // // // // // // //   const idCardRef = useRef(null);
// // // // // // // // //   const cityRef = useRef(null);
// // // // // // // // //   const specializationsRef = useRef(null); 

// // // // // // // // //   const [gender, setGender] = useState("");
// // // // // // // // //   // Defaulting to TECHNICIAN as in your original file
// // // // // // // // //   const [role, setRole] = useState("TECHNICIAN"); 
// // // // // // // // //   const [error, setError] = useState();
// // // // // // // // //   const [message, setMessage] = useState();
// // // // // // // // //   const [color, setColor] = useState("#3f51b5");
// // // // // // // // //   const [phone, setPhone] = useState("+357");
// // // // // // // // //   const [hardcopyConsent, setHardcopyConsent] = useState(false);
// // // // // // // // //   const [errors, setErrors] = useState({});
// // // // // // // // //   const { t } = useTranslation();
// // // // // // // // //   const [showPassword, setShowPassword] = useState(false);

// // // // // // // // //   const normalizePhone = (value) => {
// // // // // // // // //     if (!value) return "";
// // // // // // // // //     const trimmed = String(value).trim();
// // // // // // // // //     if (trimmed === "+357") return "";
// // // // // // // // //     return trimmed.startsWith("+") ? trimmed : `+${trimmed}`;
// // // // // // // // //   };

// // // // // // // // //   const handleSubmit = (event) => {
// // // // // // // // //     event.preventDefault();
// // // // // // // // //     setErrors({});
// // // // // // // // //     setError(undefined);
// // // // // // // // //     setMessage(undefined);

// // // // // // // // //     const emailVal = emailRef.current?.value || "";
// // // // // // // // //     const passwordVal = passwordRef.current?.value || "";
// // // // // // // // //     const phoneVal = normalizePhone(phone);

// // // // // // // // //     const localErrors = {};
// // // // // // // // //     if (!emailVal) {
// // // // // // // // //       localErrors.email = t("Email is required");
// // // // // // // // //     } else if (!emailVal.includes("@")) {
// // // // // // // // //       localErrors.email = t("Invalid email");
// // // // // // // // //     }
    
// // // // // // // // //     if (passwordVal.length < 8) localErrors.password = t("Min 8 characters");
// // // // // // // // //     if (!phoneVal) localErrors.phone_number = t("Phone is required");

// // // // // // // // //     if (Object.keys(localErrors).length) {
// // // // // // // // //       setErrors(localErrors);
// // // // // // // // //       return;
// // // // // // // // //     }

// // // // // // // // //     const payload = {
// // // // // // // // //       user_role: role, 
// // // // // // // // //       username: emailVal,
// // // // // // // // //       email: emailVal,
// // // // // // // // //       password: passwordVal,
// // // // // // // // //       first_name: nameRef.current?.value || "",
// // // // // // // // //       last_name: surnameRef.current?.value || "",
// // // // // // // // //       phone_number: phoneVal,
// // // // // // // // //       gender: gender || null,
// // // // // // // // //       date_birth: dateRef.current?.value || null,
// // // // // // // // //       id_card: idCardRef.current?.value || "",
// // // // // // // // //       city: cityRef.current?.value || "",
// // // // // // // // //       hardcopy_consent: hardcopyConsent,
// // // // // // // // //       // Logic updated to include color for both TECHNICIAN and MAID
// // // // // // // // //       ...((role === "TECHNICIAN" || role === "MAID") 
// // // // // // // // //           ? { color: color, specializations: specializationsRef.current?.value || "" } 
// // // // // // // // //           : {})
// // // // // // // // //     };

// // // // // // // // //     axiosClient
// // // // // // // // //       .post("auth/users/", payload) 
// // // // // // // // //       .then(() => {
// // // // // // // // //         setMessage(t("User added successfully"));
// // // // // // // // //         handleReset();
// // // // // // // // //       })
// // // // // // // // //       .catch((err) => {
// // // // // // // // //         const backendErrors = err.response?.data;
// // // // // // // // //         if (backendErrors && typeof backendErrors === 'object') {
// // // // // // // // //           const firstErrorKey = Object.keys(backendErrors)[0];
// // // // // // // // //           const firstErrorMsg = Array.isArray(backendErrors[firstErrorKey]) 
// // // // // // // // //             ? backendErrors[firstErrorKey][0] 
// // // // // // // // //             : backendErrors[firstErrorKey];
          
// // // // // // // // //           setError(`${firstErrorKey}: ${firstErrorMsg}`);
// // // // // // // // //           setErrors(backendErrors);
// // // // // // // // //         } else {
// // // // // // // // //           setError(t("Failed to create user. Check if email or ID Card is unique."));
// // // // // // // // //         }
// // // // // // // // //       });
// // // // // // // // //   };

// // // // // // // // //   const handleReset = () => {
// // // // // // // // //     setRole("TECHNICIAN");
// // // // // // // // //     setGender("");
// // // // // // // // //     setPhone("+357");
// // // // // // // // //     setHardcopyConsent(false);
// // // // // // // // //     setErrors({});
// // // // // // // // //     [nameRef, surnameRef, dateRef, passwordRef, emailRef, idCardRef, cityRef, specializationsRef].forEach(ref => {
// // // // // // // // //       if (ref.current) ref.current.value = "";
// // // // // // // // //     });
// // // // // // // // //   };

// // // // // // // // //   return (
// // // // // // // // //     <Card elevation={16}>
// // // // // // // // //       <CardContent>
// // // // // // // // //         <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>{t("Create New User")}</Typography>
        
// // // // // // // // //         {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // // // // // // // //         {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// // // // // // // // //         <form onSubmit={handleSubmit}>
// // // // // // // // //           <Box display="flex" alignItems="center" sx={{ mb: 3 }}>
// // // // // // // // //             <FormLabel sx={{ mr: 2, fontWeight: 'bold' }}>{t("Role")}</FormLabel>
// // // // // // // // //             <RadioGroup row value={role} onChange={(e) => setRole(e.target.value)}>
// // // // // // // // //               {/* Removed SECRETARY, added ADMIN */}
// // // // // // // // //               <FormControlLabel value="RECEPTION" control={<Radio />} label={t("Reception")} />
// // // // // // // // //               <FormControlLabel value="ADMIN" control={<Radio />} label={t("Admin")} />
// // // // // // // // //               <FormControlLabel value="TECHNICIAN" control={<Radio />} label={t("Technician")} />
// // // // // // // // //               <FormControlLabel value="MAID" control={<Radio />} label={t("Maid")} />
// // // // // // // // //             </RadioGroup>
// // // // // // // // //           </Box>

// // // // // // // // //           <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
// // // // // // // // //             <TextField fullWidth label={t("Name")} inputRef={nameRef} required />
// // // // // // // // //             <TextField fullWidth label={t("Surname")} inputRef={surnameRef} required />
            
// // // // // // // // //             <TextField 
// // // // // // // // //                 fullWidth 
// // // // // // // // //                 label={t("Email")} 
// // // // // // // // //                 type="email" 
// // // // // // // // //                 inputRef={emailRef} 
// // // // // // // // //                 required 
// // // // // // // // //                 error={!!errors.email} 
// // // // // // // // //                 helperText={errors.email || ""} 
// // // // // // // // //             />
            
// // // // // // // // //             <TextField
// // // // // // // // //               fullWidth
// // // // // // // // //               label={t("Password")}
// // // // // // // // //               type={showPassword ? "text" : "password"}
// // // // // // // // //               inputRef={passwordRef}
// // // // // // // // //               required
// // // // // // // // //               error={!!errors.password}
// // // // // // // // //               helperText={errors.password?.[0] || ""}
// // // // // // // // //               InputProps={{
// // // // // // // // //                 endAdornment: (
// // // // // // // // //                   <InputAdornment position="end">
// // // // // // // // //                     <IconButton onClick={() => setShowPassword(!showPassword)}>{showPassword ? <VisibilityOff /> : <Visibility />}</IconButton>
// // // // // // // // //                   </InputAdornment>
// // // // // // // // //                 ),
// // // // // // // // //               }}
// // // // // // // // //             />

// // // // // // // // //             <Box>
// // // // // // // // //                 <PhoneField phone={phone} setPhone={setPhone} />
// // // // // // // // //                 {errors.phone_number && <Typography color="error" variant="caption">{errors.phone_number[0]}</Typography>}
// // // // // // // // //             </Box>

// // // // // // // // //             <TextField 
// // // // // // // // //                 fullWidth 
// // // // // // // // //                 label={t("ID CARD")} 
// // // // // // // // //                 inputRef={idCardRef} 
// // // // // // // // //                 error={!!errors.id_card}
// // // // // // // // //                 helperText={errors.id_card?.[0] || ""}
// // // // // // // // //             />

// // // // // // // // //             <TextField fullWidth label={t("Date of Birth")} type="date" inputRef={dateRef} InputLabelProps={{ shrink: true }} />
            
// // // // // // // // //             <FormControl fullWidth sx={{ alignItems: "center" }}>
// // // // // // // // //               <FormLabel sx={{ fontSize: "0.8rem", textAlign: "center", width: "100%" }}>
// // // // // // // // //                 {t("GENDER (OPTIONAL)")}
// // // // // // // // //               </FormLabel>
// // // // // // // // //               <RadioGroup 
// // // // // // // // //                 row 
// // // // // // // // //                 value={gender} 
// // // // // // // // //                 onChange={(e) => setGender(e.target.value)}
// // // // // // // // //                 sx={{ justifyContent: "center" }}
// // // // // // // // //               >
// // // // // // // // //                 <FormControlLabel value="M" control={<Radio size="small" />} label={t("MALE")} />
// // // // // // // // //                 <FormControlLabel value="F" control={<Radio size="small" />} label={t("FEMALE")} />
// // // // // // // // //               </RadioGroup>
// // // // // // // // //             </FormControl>
// // // // // // // // //           </Box>

// // // // // // // // //           {/* Logic updated to show picker for both TECHNICIAN and MAID */}
// // // // // // // // //           {(role === "TECHNICIAN" || role === "MAID") && (
// // // // // // // // //             <Box sx={{ mt: 3, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
// // // // // // // // //               <TextField 
// // // // // // // // //                 fullWidth 
// // // // // // // // //                 label={t("Specializations")} 
// // // // // // // // //                 inputRef={specializationsRef} 
// // // // // // // // //                 sx={{ mb: 2 }} 
// // // // // // // // //               />
// // // // // // // // //               <Typography variant="caption" sx={{ display: 'block', mb: 1 }}>
// // // // // // // // //                 {t("Calendar Color Selection")}
// // // // // // // // //               </Typography>
// // // // // // // // //               <SketchPicker color={color} onChangeComplete={(c) => setColor(c.hex)} />
// // // // // // // // //             </Box>
// // // // // // // // //           )}

// // // // // // // // //           <Box mt={4} display="flex" gap={2}>
// // // // // // // // //             <Button type="submit" variant="contained" size="large">{t("SUBMIT")}</Button>
// // // // // // // // //             <Button type="button" variant="outlined" size="large" onClick={handleReset}>{t("RESET")}</Button>
// // // // // // // // //           </Box>
// // // // // // // // //         </form>
// // // // // // // // //       </CardContent>
// // // // // // // // //     </Card>
// // // // // // // // //   );
// // // // // // // // // };

// // // // // // // // // export default UserForm;


// // // // // // // // import GDPRPolicyLink from "../components/GDPRPolicyLink";
// // // // // // // // import { useState, useRef } from "react";
// // // // // // // // import {
// // // // // // // //   Card,
// // // // // // // //   CardContent,
// // // // // // // //   Typography,
// // // // // // // //   TextField,
// // // // // // // //   Button,
// // // // // // // //   Box,
// // // // // // // //   FormLabel,
// // // // // // // //   RadioGroup,
// // // // // // // //   FormControlLabel,
// // // // // // // //   Radio,
// // // // // // // //   InputAdornment,
// // // // // // // //   Alert,
// // // // // // // //   IconButton,
// // // // // // // //   FormControl,
// // // // // // // // } from "@mui/material";
// // // // // // // // import { SketchPicker } from "react-color";
// // // // // // // // import axiosClient from "../axiosClient";
// // // // // // // // import { useTranslation } from "react-i18next";
// // // // // // // // import PhoneField from "../components/PhoneField";
// // // // // // // // import { Visibility, VisibilityOff } from "@mui/icons-material";

// // // // // // // // const UserForm = () => {
// // // // // // // //   const nameRef = useRef(null);
// // // // // // // //   const surnameRef = useRef(null);
// // // // // // // //   const dateRef = useRef(null);
// // // // // // // //   const passwordRef = useRef(null);
// // // // // // // //   const emailRef = useRef(null);
// // // // // // // //   const idCardRef = useRef(null);
// // // // // // // //   const cityRef = useRef(null);
// // // // // // // //   const specializationsRef = useRef(null); 

// // // // // // // //   const [gender, setGender] = useState("");
// // // // // // // //   const [role, setRole] = useState("TECHNICIAN"); 
// // // // // // // //   const [error, setError] = useState();
// // // // // // // //   const [message, setMessage] = useState();
// // // // // // // //   const [color, setColor] = useState("#3f51b5");
// // // // // // // //   const [phone, setPhone] = useState("+357");
// // // // // // // //   const [hardcopyConsent, setHardcopyConsent] = useState(false);
// // // // // // // //   const [errors, setErrors] = useState({});
// // // // // // // //   const { t } = useTranslation();
// // // // // // // //   const [showPassword, setShowPassword] = useState(false);

// // // // // // // //   const normalizePhone = (value) => {
// // // // // // // //     if (!value) return "";
// // // // // // // //     const trimmed = String(value).trim();
// // // // // // // //     if (trimmed === "+357") return "";
// // // // // // // //     return trimmed.startsWith("+") ? trimmed : `+${trimmed}`;
// // // // // // // //   };

// // // // // // // //   const handleSubmit = (event) => {
// // // // // // // //     event.preventDefault();
// // // // // // // //     setErrors({});
// // // // // // // //     setError(undefined);
// // // // // // // //     setMessage(undefined);

// // // // // // // //     const emailVal = emailRef.current?.value || "";
// // // // // // // //     const passwordVal = passwordRef.current?.value || "";
// // // // // // // //     const phoneVal = normalizePhone(phone);

// // // // // // // //     const localErrors = {};
// // // // // // // //     if (!emailVal) localErrors.email = t("Email is required");
// // // // // // // //     if (passwordVal.length < 8) localErrors.password = t("Min 8 characters");
// // // // // // // //     if (!phoneVal) localErrors.phone_number = t("Phone is required");

// // // // // // // //     if (Object.keys(localErrors).length) {
// // // // // // // //       setErrors(localErrors);
// // // // // // // //       return;
// // // // // // // //     }

// // // // // // // //     const payload = {
// // // // // // // //       user_role: role, 
// // // // // // // //       username: emailVal,
// // // // // // // //       email: emailVal,
// // // // // // // //       password: passwordVal,
// // // // // // // //       first_name: nameRef.current?.value || "",
// // // // // // // //       last_name: surnameRef.current?.value || "",
// // // // // // // //       phone_number: phoneVal,
// // // // // // // //       gender: gender || null,
// // // // // // // //       date_birth: dateRef.current?.value || null,
// // // // // // // //       id_card: idCardRef.current?.value || "",
// // // // // // // //       city: cityRef.current?.value || "",
// // // // // // // //       hardcopy_consent: hardcopyConsent,
// // // // // // // //       ...((role === "TECHNICIAN" || role === "MAID") 
// // // // // // // //           ? { color: color, specializations: specializationsRef.current?.value || "" } 
// // // // // // // //           : {})
// // // // // // // //     };

// // // // // // // //     axiosClient.post("auth/users/", payload) 
// // // // // // // //       .then(() => {
// // // // // // // //         setMessage(t("User added successfully"));
// // // // // // // //         handleReset();
// // // // // // // //       })
// // // // // // // //       .catch((err) => {
// // // // // // // //         setError(t("Failed to create user. Ensure Email/ID Card is unique."));
// // // // // // // //       });
// // // // // // // //   };

// // // // // // // //   const handleReset = () => {
// // // // // // // //     setRole("TECHNICIAN");
// // // // // // // //     setGender("");
// // // // // // // //     setPhone("+357");
// // // // // // // //     setErrors({});
// // // // // // // //     [nameRef, surnameRef, dateRef, passwordRef, emailRef, idCardRef, cityRef, specializationsRef].forEach(ref => {
// // // // // // // //       if (ref.current) ref.current.value = "";
// // // // // // // //     });
// // // // // // // //   };

// // // // // // // //   return (
// // // // // // // //     <Card elevation={16}>
// // // // // // // //       <CardContent>
// // // // // // // //         <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>{t("Create New User")}</Typography>
        
// // // // // // // //         {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // // // // // // //         {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// // // // // // // //         <form onSubmit={handleSubmit}>
// // // // // // // //           <Box display="flex" alignItems="center" sx={{ mb: 3 }}>
// // // // // // // //             <FormLabel sx={{ mr: 2, fontWeight: 'bold' }}>{t("Role")}</FormLabel>
// // // // // // // //             <RadioGroup row value={role} onChange={(e) => setRole(e.target.value)}>
// // // // // // // //               {/* CLEANED: Removed Secretary, kept Reception, Admin, Technician, Maid */}
// // // // // // // //               <FormControlLabel value="RECEPTION" control={<Radio />} label={t("Reception")} />
// // // // // // // //               <FormControlLabel value="ADMIN" control={<Radio />} label={t("Admin")} />
// // // // // // // //               <FormControlLabel value="TECHNICIAN" control={<Radio />} label={t("Technician")} />
// // // // // // // //               <FormControlLabel value="MAID" control={<Radio />} label={t("Maid")} />
// // // // // // // //             </RadioGroup>
// // // // // // // //           </Box>

// // // // // // // //           <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
// // // // // // // //             <TextField fullWidth label={t("Name")} inputRef={nameRef} required />
// // // // // // // //             <TextField fullWidth label={t("Surname")} inputRef={surnameRef} required />
// // // // // // // //             <TextField fullWidth label={t("Email")} inputRef={emailRef} required />
// // // // // // // //             <TextField
// // // // // // // //               fullWidth
// // // // // // // //               label={t("Password")}
// // // // // // // //               type={showPassword ? "text" : "password"}
// // // // // // // //               inputRef={passwordRef}
// // // // // // // //               required
// // // // // // // //               InputProps={{
// // // // // // // //                 endAdornment: (
// // // // // // // //                   <InputAdornment position="end">
// // // // // // // //                     <IconButton onClick={() => setShowPassword(!showPassword)}>{showPassword ? <VisibilityOff /> : <Visibility />}</IconButton>
// // // // // // // //                   </InputAdornment>
// // // // // // // //                 ),
// // // // // // // //               }}
// // // // // // // //             />
// // // // // // // //           </Box>

// // // // // // // //           {(role === "TECHNICIAN" || role === "MAID") && (
// // // // // // // //             <Box sx={{ mt: 3, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
// // // // // // // //               <TextField fullWidth label={t("Specializations")} inputRef={specializationsRef} sx={{ mb: 2 }} />
// // // // // // // //               <Typography variant="caption" sx={{ display: 'block', mb: 1 }}>{t("Calendar Color Selection")}</Typography>
// // // // // // // //               <SketchPicker color={color} onChangeComplete={(c) => setColor(c.hex)} />
// // // // // // // //             </Box>
// // // // // // // //           )}

// // // // // // // //           <Box mt={4} display="flex" gap={2}>
// // // // // // // //             <Button type="submit" variant="contained" size="large">{t("SUBMIT")}</Button>
// // // // // // // //             <Button type="button" variant="outlined" size="large" onClick={handleReset}>{t("RESET")}</Button>
// // // // // // // //           </Box>
// // // // // // // //         </form>
// // // // // // // //       </CardContent>
// // // // // // // //     </Card>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // export default UserForm;


// // // // // // // import GDPRPolicyLink from "../components/GDPRPolicyLink";
// // // // // // // import { useState, useRef } from "react";
// // // // // // // import {
// // // // // // //   Card,
// // // // // // //   CardContent,
// // // // // // //   Typography,
// // // // // // //   TextField,
// // // // // // //   Button,
// // // // // // //   Box,
// // // // // // //   FormLabel,
// // // // // // //   RadioGroup,
// // // // // // //   FormControlLabel,
// // // // // // //   Radio,
// // // // // // //   InputAdornment,
// // // // // // //   Alert,
// // // // // // //   IconButton,
// // // // // // //   FormControl,
// // // // // // // } from "@mui/material";
// // // // // // // import { SketchPicker } from "react-color";
// // // // // // // import axiosClient from "../axiosClient";
// // // // // // // import { useTranslation } from "react-i18next";
// // // // // // // import PhoneField from "../components/PhoneField";
// // // // // // // import { Visibility, VisibilityOff } from "@mui/icons-material";

// // // // // // // const UserForm = () => {
// // // // // // //   const nameRef = useRef(null);
// // // // // // //   const surnameRef = useRef(null);
// // // // // // //   const dateRef = useRef(null);
// // // // // // //   const passwordRef = useRef(null);
// // // // // // //   const emailRef = useRef(null);
// // // // // // //   const cityRef = useRef(null);
// // // // // // //   const specializationsRef = useRef(null); 

// // // // // // //   const [gender, setGender] = useState("");
// // // // // // //   const [role, setRole] = useState("TECHNICIAN"); 
// // // // // // //   const [error, setError] = useState();
// // // // // // //   const [message, setMessage] = useState();
// // // // // // //   const [color, setColor] = useState("#3f51b5");
// // // // // // //   const [phone, setPhone] = useState("+357");
// // // // // // //   const [hardcopyConsent, setHardcopyConsent] = useState(false);
// // // // // // //   const [errors, setErrors] = useState({});
// // // // // // //   const { t } = useTranslation();
// // // // // // //   const [showPassword, setShowPassword] = useState(false);

// // // // // // //   const normalizePhone = (value) => {
// // // // // // //     if (!value) return "";
// // // // // // //     const trimmed = String(value).trim();
// // // // // // //     if (trimmed === "+357") return "";
// // // // // // //     return trimmed.startsWith("+") ? trimmed : `+${trimmed}`;
// // // // // // //   };

// // // // // // //   const handleSubmit = (event) => {
// // // // // // //     event.preventDefault();
// // // // // // //     setErrors({});
// // // // // // //     setError(undefined);
// // // // // // //     setMessage(undefined);

// // // // // // //     const emailVal = emailRef.current?.value || "";
// // // // // // //     const passwordVal = passwordRef.current?.value || "";
// // // // // // //     const phoneVal = normalizePhone(phone);

// // // // // // //     const localErrors = {};
// // // // // // //     if (!emailVal) localErrors.email = t("Email is required");
// // // // // // //     if (passwordVal.length < 8) localErrors.password = t("Min 8 characters");
// // // // // // //     if (!phoneVal) localErrors.phone_number = t("Phone is required");

// // // // // // //     if (Object.keys(localErrors).length) {
// // // // // // //       setErrors(localErrors);
// // // // // // //       return;
// // // // // // //     }

// // // // // // //     const payload = {
// // // // // // //       user_role: role, 
// // // // // // //       username: emailVal, // Set username to email as per Django requirement
// // // // // // //       email: emailVal,
// // // // // // //       password: passwordVal,
// // // // // // //       first_name: nameRef.current?.value || "",
// // // // // // //       last_name: surnameRef.current?.value || "",
// // // // // // //       phone_number: phoneVal,
// // // // // // //       gender: gender || null,
// // // // // // //       date_birth: dateRef.current?.value || null,
// // // // // // //       city: cityRef.current?.value || "",
// // // // // // //       hardcopy_consent: hardcopyConsent,
// // // // // // //       // Color and Specialization logic for Tech and Maid
// // // // // // //       ...((role === "TECHNICIAN" || role === "MAID") 
// // // // // // //           ? { color: color, specializations: specializationsRef.current?.value || "" } 
// // // // // // //           : {})
// // // // // // //     };

// // // // // // //     axiosClient.post("auth/users/", payload) 
// // // // // // //       .then(() => {
// // // // // // //         setMessage(t("User added successfully"));
// // // // // // //         handleReset();
// // // // // // //       })
// // // // // // //       .catch((err) => {
// // // // // // //         // Show detailed error if available
// // // // // // //         const backendError = err.response?.data;
// // // // // // //         setError(backendError ? JSON.stringify(backendError) : t("Failed to create user. Ensure Email is unique."));
// // // // // // //       });
// // // // // // //   };

// // // // // // //   const handleReset = () => {
// // // // // // //     setRole("TECHNICIAN");
// // // // // // //     setGender("");
// // // // // // //     setPhone("+357");
// // // // // // //     setErrors({});
// // // // // // //     [nameRef, surnameRef, dateRef, passwordRef, emailRef, cityRef, specializationsRef].forEach(ref => {
// // // // // // //       if (ref.current) ref.current.value = "";
// // // // // // //     });
// // // // // // //   };

// // // // // // //   return (
// // // // // // //     <Card elevation={16}>
// // // // // // //       <CardContent>
// // // // // // //         <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>{t("Create New User")}</Typography>
        
// // // // // // //         {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // // // // // //         {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// // // // // // //         <form onSubmit={handleSubmit}>
// // // // // // //           <Box display="flex" alignItems="center" sx={{ mb: 3 }}>
// // // // // // //             <FormLabel sx={{ mr: 2, fontWeight: 'bold' }}>{t("Role")}</FormLabel>
// // // // // // //             <RadioGroup row value={role} onChange={(e) => setRole(e.target.value)}>
// // // // // // //               <FormControlLabel value="RECEPTION" control={<Radio />} label={t("Reception")} />
// // // // // // //               <FormControlLabel value="ADMIN" control={<Radio />} label={t("Admin")} />
// // // // // // //               <FormControlLabel value="TECHNICIAN" control={<Radio />} label={t("Technician")} />
// // // // // // //               <FormControlLabel value="MAID" control={<Radio />} label={t("Maid")} />
// // // // // // //             </RadioGroup>
// // // // // // //           </Box>

// // // // // // //           <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
// // // // // // //             <TextField fullWidth label={t("Name")} inputRef={nameRef} required />
// // // // // // //             <TextField fullWidth label={t("Surname")} inputRef={surnameRef} required />
// // // // // // //             <TextField fullWidth label={t("Email")} inputRef={emailRef} required />
// // // // // // //             <TextField
// // // // // // //               fullWidth
// // // // // // //               label={t("Password")}
// // // // // // //               type={showPassword ? "text" : "password"}
// // // // // // //               inputRef={passwordRef}
// // // // // // //               required
// // // // // // //               InputProps={{
// // // // // // //                 endAdornment: (
// // // // // // //                   <InputAdornment position="end">
// // // // // // //                     <IconButton onClick={() => setShowPassword(!showPassword)}>{showPassword ? <VisibilityOff /> : <Visibility />}</IconButton>
// // // // // // //                   </InputAdornment>
// // // // // // //                 ),
// // // // // // //               }}
// // // // // // //             />
// // // // // // //           </Box>

// // // // // // //           {(role === "TECHNICIAN" || role === "MAID") && (
// // // // // // //             <Box sx={{ mt: 3, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
// // // // // // //               <TextField fullWidth label={t("Specializations")} inputRef={specializationsRef} sx={{ mb: 2 }} />
// // // // // // //               <Typography variant="caption" sx={{ display: 'block', mb: 1 }}>{t("Calendar Color Selection")}</Typography>
// // // // // // //               <SketchPicker color={color} onChangeComplete={(c) => setColor(c.hex)} />
// // // // // // //             </Box>
// // // // // // //           )}

// // // // // // //           <Box mt={4} display="flex" gap={2}>
// // // // // // //             <Button type="submit" variant="contained" size="large">{t("SUBMIT")}</Button>
// // // // // // //             <Button type="button" variant="outlined" size="large" onClick={handleReset}>{t("RESET")}</Button>
// // // // // // //           </Box>
// // // // // // //         </form>
// // // // // // //       </CardContent>
// // // // // // //     </Card>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default UserForm;


// // // // // // import { useState, useRef } from "react";
// // // // // // import { Card, CardContent, Typography, TextField, Button, Box, FormLabel, RadioGroup, FormControlLabel, Radio, InputAdornment, Alert, IconButton } from "@mui/material";
// // // // // // import { SketchPicker } from "react-color";
// // // // // // import axiosClient from "../axiosClient";
// // // // // // import { useTranslation } from "react-i18next";
// // // // // // import PhoneField from "../components/PhoneField";
// // // // // // import { Visibility, VisibilityOff } from "@mui/icons-material";

// // // // // // const UserForm = () => {
// // // // // //   const nameRef = useRef(null);
// // // // // //   const surnameRef = useRef(null);
// // // // // //   const passwordRef = useRef(null);
// // // // // //   const emailRef = useRef(null);
// // // // // //   const cityRef = useRef(null);
// // // // // //   const specializationsRef = useRef(null); 

// // // // // //   const [role, setRole] = useState("TECHNICIAN"); 
// // // // // //   const [error, setError] = useState();
// // // // // //   const [message, setMessage] = useState();
// // // // // //   const [color, setColor] = useState("#3f51b5");
// // // // // //   const [phone, setPhone] = useState("+357");
// // // // // //   const [errors, setErrors] = useState({});
// // // // // //   const { t } = useTranslation();
// // // // // //   const [showPassword, setShowPassword] = useState(false);

// // // // // //   const handleSubmit = (event) => {
// // // // // //     event.preventDefault();
// // // // // //     console.log("Submit clicked!"); // Check F12 Console for this
// // // // // //     setErrors({});
// // // // // //     setError(undefined);
// // // // // //     setMessage(undefined);

// // // // // //     const payload = {
// // // // // //       user_role: role, 
// // // // // //       username: emailRef.current?.value,
// // // // // //       email: emailRef.current?.value,
// // // // // //       password: passwordRef.current?.value,
// // // // // //       first_name: nameRef.current?.value || "",
// // // // // //       last_name: surnameRef.current?.value || "",
// // // // // //       phone_number: phone, // Ensure PhoneField is updating this state
// // // // // //       city: cityRef.current?.value || "",
// // // // // //       ...((role === "TECHNICIAN" || role === "MAID") 
// // // // // //           ? { color: color, specializations: specializationsRef.current?.value || "" } 
// // // // // //           : {})
// // // // // //     };

// // // // // //     console.log("Sending Payload:", payload);

// // // // // //     axiosClient.post("auth/users/", payload) 
// // // // // //       .then(() => {
// // // // // //         setMessage(t("User added successfully"));
// // // // // //         // handleReset();
// // // // // //       })
// // // // // //       .catch((err) => {
// // // // // //         console.error("Backend Error:", err.response?.data);
// // // // // //         const backendMsg = err.response?.data;
// // // // // //         setError(backendMsg ? JSON.stringify(backendMsg) : t("Check console for errors"));
// // // // // //       });
// // // // // //   };

// // // // // //   return (
// // // // // //     <Card elevation={16}>
// // // // // //       <CardContent>
// // // // // //         <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>{t("Create New User")}</Typography>
// // // // // //         {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // // // // //         {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// // // // // //         <form onSubmit={handleSubmit}>
// // // // // //           <Box sx={{ mb: 3 }}>
// // // // // //             <FormLabel sx={{ fontWeight: 'bold' }}>{t("Role")}</FormLabel>
// // // // // //             <RadioGroup row value={role} onChange={(e) => setRole(e.target.value)}>
// // // // // //               <FormControlLabel value="RECEPTION" control={<Radio />} label={t("Reception")} />
// // // // // //               <FormControlLabel value="ADMIN" control={<Radio />} label={t("Admin")} />
// // // // // //               <FormControlLabel value="TECHNICIAN" control={<Radio />} label={t("Technician")} />
// // // // // //               <FormControlLabel value="MAID" control={<Radio />} label={t("Maid")} />
// // // // // //             </RadioGroup>
// // // // // //           </Box>

// // // // // //           <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
// // // // // //             <TextField fullWidth label={t("Name")} inputRef={nameRef} required />
// // // // // //             <TextField fullWidth label={t("Surname")} inputRef={surnameRef} required />
// // // // // //             <TextField fullWidth label={t("Email")} inputRef={emailRef} required />
// // // // // //             <TextField fullWidth label={t("Password")} type={showPassword ? "text" : "password"} inputRef={passwordRef} required />
// // // // // //             <Box><PhoneField phone={phone} setPhone={setPhone} /></Box>
// // // // // //             <TextField fullWidth label={t("City")} inputRef={cityRef} />
// // // // // //           </Box>

// // // // // //           {(role === "TECHNICIAN" || role === "MAID") && (
// // // // // //             <Box sx={{ mt: 3, p: 2, bgcolor: "#f5f5f5" }}>
// // // // // //               <TextField fullWidth label={t("Specializations")} inputRef={specializationsRef} sx={{ mb: 2 }} />
// // // // // //               <SketchPicker color={color} onChangeComplete={(c) => setColor(c.hex)} />
// // // // // //             </Box>
// // // // // //           )}

// // // // // //           <Box mt={4}><Button type="submit" variant="contained">{t("SUBMIT")}</Button></Box>
// // // // // //         </form>
// // // // // //       </CardContent>
// // // // // //     </Card>
// // // // // //   );
// // // // // // };
// // // // // // export default UserForm;

// // // // // import GDPRPolicyLink from "../components/GDPRPolicyLink";
// // // // // import { useState, useRef } from "react";
// // // // // import {
// // // // //   Card,
// // // // //   CardContent,
// // // // //   Typography,
// // // // //   TextField,
// // // // //   Button,
// // // // //   Box,
// // // // //   FormLabel,
// // // // //   RadioGroup,
// // // // //   FormControlLabel,
// // // // //   Radio,
// // // // //   InputAdornment,
// // // // //   Alert,
// // // // //   IconButton,
// // // // // } from "@mui/material";
// // // // // import { SketchPicker } from "react-color";
// // // // // import axiosClient from "../axiosClient";
// // // // // import { useTranslation } from "react-i18next";
// // // // // import PhoneField from "../components/PhoneField";
// // // // // import { Visibility, VisibilityOff } from "@mui/icons-material";

// // // // // const UserForm = () => {
// // // // //   const nameRef = useRef(null);
// // // // //   const surnameRef = useRef(null);
// // // // //   const dateRef = useRef(null);
// // // // //   const passwordRef = useRef(null);
// // // // //   const emailRef = useRef(null);
// // // // //   const cityRef = useRef(null);
// // // // //   const specializationsRef = useRef(null);

// // // // //   const [gender, setGender] = useState("");
// // // // //   const [role, setRole] = useState("TECHNICIAN");
// // // // //   const [error, setError] = useState();
// // // // //   const [message, setMessage] = useState();
// // // // //   const [color, setColor] = useState("#3f51b5");
// // // // //   const [phone, setPhone] = useState("+357");
// // // // //   const [errors, setErrors] = useState({});
// // // // //   const { t } = useTranslation();
// // // // //   const [showPassword, setShowPassword] = useState(false);

// // // // //   // Cleans the phone number to satisfy Django's PhoneNumberField requirements
// // // // //   const normalizePhone = (value) => {
// // // // //     if (!value) return "";
// // // // //     const cleanNumber = String(value).replace(/[\s\-\(\)]/g, ""); // Removes spaces/dashes
// // // // //     if (cleanNumber === "+357") return "";
// // // // //     return cleanNumber.startsWith("+") ? cleanNumber : `+${cleanNumber}`;
// // // // //   };

// // // // //   const handleSubmit = (event) => {
// // // // //     event.preventDefault();
// // // // //     setErrors({});
// // // // //     setError(undefined);
// // // // //     setMessage(undefined);

// // // // //     const emailVal = emailRef.current?.value || "";
// // // // //     const passwordVal = passwordRef.current?.value || "";
// // // // //     const phoneVal = normalizePhone(phone); // Normalization step

// // // // //     // Local validation to prevent "stuck" submissions
// // // // //     const localErrors = {};
// // // // //     if (!emailVal) localErrors.email = t("Email is required");
// // // // //     if (passwordVal.length < 8) localErrors.password = t("Min 8 characters");
// // // // //     if (!phoneVal) localErrors.phone_number = t("Phone is required");

// // // // //     if (Object.keys(localErrors).length) {
// // // // //       setErrors(localErrors);
// // // // //       return;
// // // // //     }

// // // // //     const payload = {
// // // // //       user_role: role,
// // // // //       username: emailVal, // Set username to email as required by backend
// // // // //       email: emailVal,
// // // // //       password: passwordVal,
// // // // //       first_name: nameRef.current?.value || "",
// // // // //       last_name: surnameRef.current?.value || "",
// // // // //       phone_number: phoneVal,
// // // // //       gender: gender || null,
// // // // //       date_birth: dateRef.current?.value || null,
// // // // //       city: cityRef.current?.value || "",
// // // // //       // Color/Specialization included for both Technician and Maid
// // // // //       ...((role === "TECHNICIAN" || role === "MAID")
// // // // //         ? { color: color, specializations: specializationsRef.current?.value || "" }
// // // // //         : {})
// // // // //     };

// // // // //     axiosClient.post("auth/users/", payload)
// // // // //       .then(() => {
// // // // //         setMessage(t("User added successfully"));
// // // // //         handleReset();
// // // // //       })
// // // // //       .catch((err) => {
// // // // //         const backendErrors = err.response?.data;
// // // // //         // Display exact reason for failure (e.g., Email already exists)
// // // // //         setError(backendErrors ? JSON.stringify(backendErrors) : t("Failed to create user."));
// // // // //         if (backendErrors) setErrors(backendErrors);
// // // // //       });
// // // // //   };

// // // // //   const handleReset = () => {
// // // // //     setRole("TECHNICIAN");
// // // // //     setGender("");
// // // // //     setPhone("+357");
// // // // //     setErrors({});
// // // // //     [nameRef, surnameRef, dateRef, passwordRef, emailRef, cityRef, specializationsRef].forEach(ref => {
// // // // //       if (ref.current) ref.current.value = "";
// // // // //     });
// // // // //   };

// // // // //   return (
// // // // //     <Card elevation={16}>
// // // // //       <CardContent>
// // // // //         <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
// // // // //           {t("Create New User")}
// // // // //         </Typography>

// // // // //         {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // // // //         {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// // // // //         <form onSubmit={handleSubmit}>
// // // // //           <Box display="flex" alignItems="center" sx={{ mb: 3 }}>
// // // // //             <FormLabel sx={{ mr: 2, fontWeight: 'bold' }}>{t("Role")}</FormLabel>
// // // // //             <RadioGroup row value={role} onChange={(e) => setRole(e.target.value)}>
// // // // //               <FormControlLabel value="RECEPTION" control={<Radio />} label={t("Reception")} />
// // // // //               <FormControlLabel value="ADMIN" control={<Radio />} label={t("Admin")} />
// // // // //               <FormControlLabel value="TECHNICIAN" control={<Radio />} label={t("Technician")} />
// // // // //               <FormControlLabel value="MAID" control={<Radio />} label={t("Maid")} />
// // // // //             </RadioGroup>
// // // // //           </Box>

// // // // //           <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
// // // // //             <TextField fullWidth label={t("Name")} inputRef={nameRef} required />
// // // // //             <TextField fullWidth label={t("Surname")} inputRef={surnameRef} required />
// // // // //             <TextField 
// // // // //               fullWidth 
// // // // //               label={t("Email")} 
// // // // //               type="email" 
// // // // //               inputRef={emailRef} 
// // // // //               required 
// // // // //               error={!!errors.email}
// // // // //               helperText={errors.email || ""}
// // // // //             />
// // // // //             <TextField
// // // // //               fullWidth
// // // // //               label={t("Password")}
// // // // //               type={showPassword ? "text" : "password"}
// // // // //               inputRef={passwordRef}
// // // // //               required
// // // // //               InputProps={{
// // // // //                 endAdornment: (
// // // // //                   <InputAdornment position="end">
// // // // //                     <IconButton onClick={() => setShowPassword(!showPassword)}>
// // // // //                       {showPassword ? <VisibilityOff /> : <Visibility />}
// // // // //                     </IconButton>
// // // // //                   </InputAdornment>
// // // // //                 ),
// // // // //               }}
// // // // //             />
// // // // //             <Box>
// // // // //               <PhoneField phone={phone} setPhone={setPhone} />
// // // // //               {errors.phone_number && (
// // // // //                 <Typography color="error" variant="caption">
// // // // //                   {t("Invalid Phone Number")}
// // // // //                 </Typography>
// // // // //               )}
// // // // //             </Box>
// // // // //             <TextField fullWidth label={t("City")} inputRef={cityRef} />
// // // // //           </Box>

// // // // //           {(role === "TECHNICIAN" || role === "MAID") && (
// // // // //             <Box sx={{ mt: 3, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
// // // // //               <TextField 
// // // // //                 fullWidth 
// // // // //                 label={t("Specializations")} 
// // // // //                 inputRef={specializationsRef} 
// // // // //                 sx={{ mb: 2 }} 
// // // // //               />
// // // // //               <Typography variant="caption" sx={{ display: 'block', mb: 1 }}>
// // // // //                 {t("Calendar Color Selection")}
// // // // //               </Typography>
// // // // //               <SketchPicker color={color} onChangeComplete={(c) => setColor(c.hex)} />
// // // // //             </Box>
// // // // //           )}

// // // // //           <Box mt={4} display="flex" gap={2}>
// // // // //             <Button type="submit" variant="contained" size="large">{t("SUBMIT")}</Button>
// // // // //             <Button type="button" variant="outlined" size="large" onClick={handleReset}>{t("RESET")}</Button>
// // // // //           </Box>
// // // // //         </form>
// // // // //       </CardContent>
// // // // //     </Card>
// // // // //   );
// // // // // };

// // // // // export default UserForm;



// // // // import GDPRPolicyLink from "../components/GDPRPolicyLink";
// // // // import { useState, useRef } from "react";
// // // // import {
// // // //   Card,
// // // //   CardContent,
// // // //   Typography,
// // // //   TextField,
// // // //   Button,
// // // //   Box,
// // // //   FormLabel,
// // // //   RadioGroup,
// // // //   FormControlLabel,
// // // //   Radio,
// // // //   InputAdornment,
// // // //   Alert,
// // // //   IconButton,
// // // // } from "@mui/material";
// // // // import { SketchPicker } from "react-color";
// // // // import axiosClient from "../axiosClient";
// // // // import { useTranslation } from "react-i18next";
// // // // import PhoneField from "../components/PhoneField";
// // // // import { Visibility, VisibilityOff } from "@mui/icons-material";

// // // // const UserForm = () => {
// // // //   const nameRef = useRef(null);
// // // //   const surnameRef = useRef(null);
// // // //   const dateRef = useRef(null);
// // // //   const passwordRef = useRef(null);
// // // //   const emailRef = useRef(null);
// // // //   const cityRef = useRef(null);
// // // //   const specializationsRef = useRef(null);

// // // //   const [gender, setGender] = useState("");
// // // //   const [role, setRole] = useState("TECHNICIAN");
// // // //   const [error, setError] = useState();
// // // //   const [message, setMessage] = useState();
// // // //   const [color, setColor] = useState("#3f51b5");
// // // //   const [phone, setPhone] = useState("+357");
// // // //   const [errors, setErrors] = useState({});
// // // //   const { t } = useTranslation();
// // // //   const [showPassword, setShowPassword] = useState(false);

// // // //   // Normalizes the phone number to strip spaces/dashes for the backend
// // // //   const normalizePhone = (value) => {
// // // //     if (!value) return "";
// // // //     const cleanNumber = String(value).replace(/[\s\-\(\)]/g, ""); 
// // // //     if (cleanNumber === "+357") return "";
// // // //     return cleanNumber.startsWith("+") ? cleanNumber : `+${cleanNumber}`;
// // // //   };

// // // //   const handleSubmit = (event) => {
// // // //     event.preventDefault();
// // // //     setErrors({});
// // // //     setError(undefined);
// // // //     setMessage(undefined);

// // // //     const emailVal = emailRef.current?.value || "";
// // // //     const passwordVal = passwordRef.current?.value || "";
// // // //     const phoneVal = normalizePhone(phone);

// // // //     // Front-end basic validation
// // // //     const localErrors = {};
// // // //     if (!emailVal) localErrors.email = t("Email is required");
// // // //     if (passwordVal.length < 8) localErrors.password = t("Min 8 characters");
// // // //     if (!phoneVal || phoneVal === "+357") localErrors.phone_number = t("Phone is required");

// // // //     if (Object.keys(localErrors).length) {
// // // //       setErrors(localErrors);
// // // //       return;
// // // //     }

// // // //     const payload = {
// // // //       user_role: role,
// // // //       username: emailVal, // Backend requires a username; using email is standard here
// // // //       email: emailVal,
// // // //       password: passwordVal,
// // // //       first_name: nameRef.current?.value || "",
// // // //       last_name: surnameRef.current?.value || "",
// // // //       phone_number: phoneVal,
// // // //       gender: gender || null,
// // // //       date_birth: dateRef.current?.value || null,
// // // //       city: cityRef.current?.value || "",
// // // //       ...((role === "TECHNICIAN" || role === "MAID")
// // // //         ? { color: color, specializations: specializationsRef.current?.value || "" }
// // // //         : {})
// // // //     };

// // // //     console.log("Sending Payload:", payload);

// // // //     axiosClient.post("auth/users/", payload)
// // // //       .then(() => {
// // // //         setMessage(t("User added successfully"));
// // // //         handleReset();
// // // //       })
// // // //       .catch((err) => {
// // // //         const backendMsg = err.response?.data;
// // // //         console.error("Backend Error:", backendMsg);
// // // //         // Show specific error (like "Email already exists" or "Invalid Phone")
// // // //         setError(backendMsg ? JSON.stringify(backendMsg) : t("Failed to create user."));
// // // //         if (backendMsg) setErrors(backendMsg);
// // // //       });
// // // //   };

// // // //   const handleReset = () => {
// // // //     setRole("TECHNICIAN");
// // // //     setGender("");
// // // //     setPhone("+357");
// // // //     setErrors({});
// // // //     [nameRef, surnameRef, dateRef, passwordRef, emailRef, cityRef, specializationsRef].forEach(ref => {
// // // //       if (ref.current) ref.current.value = "";
// // // //     });
// // // //   };

// // // //   return (
// // // //     <Card elevation={16}>
// // // //       <CardContent>
// // // //         <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
// // // //           {t("Create New User")}
// // // //         </Typography>

// // // //         {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // // //         {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// // // //         <form onSubmit={handleSubmit}>
// // // //           <Box display="flex" alignItems="center" sx={{ mb: 3 }}>
// // // //             <FormLabel sx={{ mr: 2, fontWeight: 'bold' }}>{t("Role")}</FormLabel>
// // // //             <RadioGroup row value={role} onChange={(e) => setRole(e.target.value)}>
// // // //               <FormControlLabel value="RECEPTION" control={<Radio />} label={t("Reception")} />
// // // //               <FormControlLabel value="ADMIN" control={<Radio />} label={t("Admin")} />
// // // //               <FormControlLabel value="TECHNICIAN" control={<Radio />} label={t("Technician")} />
// // // //               <FormControlLabel value="MAID" control={<Radio />} label={t("Maid")} />
// // // //             </RadioGroup>
// // // //           </Box>

// // // //           <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
// // // //             <TextField fullWidth label={t("Name")} inputRef={nameRef} required />
// // // //             <TextField fullWidth label={t("Surname")} inputRef={surnameRef} required />
// // // //             <TextField 
// // // //               fullWidth 
// // // //               label={t("Email")} 
// // // //               type="email" 
// // // //               inputRef={emailRef} 
// // // //               required 
// // // //               error={!!errors.email}
// // // //               helperText={errors.email}
// // // //             />
// // // //             <TextField
// // // //               fullWidth
// // // //               label={t("Password")}
// // // //               type={showPassword ? "text" : "password"}
// // // //               inputRef={passwordRef}
// // // //               required
// // // //               error={!!errors.password}
// // // //               helperText={errors.password}
// // // //               InputProps={{
// // // //                 endAdornment: (
// // // //                   <InputAdornment position="end">
// // // //                     <IconButton onClick={() => setShowPassword(!showPassword)}>
// // // //                       {showPassword ? <VisibilityOff /> : <Visibility />}
// // // //                     </IconButton>
// // // //                   </InputAdornment>
// // // //                 ),
// // // //               }}
// // // //             />
// // // //             <Box>
// // // //               <PhoneField phone={phone} setPhone={setPhone} />
// // // //               {(errors.phone_number || errors.phone) && (
// // // //                 <Typography color="error" variant="caption" sx={{ ml: 1 }}>
// // // //                   {t("The phone number entered is not valid.")}
// // // //                 </Typography>
// // // //               )}
// // // //             </Box>
// // // //             <TextField fullWidth label={t("City")} inputRef={cityRef} />
// // // //           </Box>

// // // //           {(role === "TECHNICIAN" || role === "MAID") && (
// // // //             <Box sx={{ mt: 3, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
// // // //               <TextField 
// // // //                 fullWidth 
// // // //                 label={t("Specializations")} 
// // // //                 inputRef={specializationsRef} 
// // // //                 sx={{ mb: 2 }} 
// // // //               />
// // // //               <Typography variant="caption" sx={{ display: 'block', mb: 1 }}>
// // // //                 {t("Calendar Color Selection")}
// // // //               </Typography>
// // // //               <SketchPicker color={color} onChangeComplete={(c) => setColor(c.hex)} />
// // // //             </Box>
// // // //           )}

// // // //           <Box mt={4} display="flex" gap={2}>
// // // //             <Button type="submit" variant="contained" size="large">{t("SUBMIT")}</Button>
// // // //             <Button type="button" variant="outlined" size="large" onClick={handleReset}>{t("RESET")}</Button>
// // // //           </Box>
// // // //         </form>
// // // //       </CardContent>
// // // //     </Card>
// // // //   );
// // // // };

// // // // export default UserForm;


// // // import GDPRPolicyLink from "../components/GDPRPolicyLink";
// // // import { useState, useRef } from "react";
// // // import {
// // //   Card,
// // //   CardContent,
// // //   Typography,
// // //   TextField,
// // //   Button,
// // //   Box,
// // //   FormLabel,
// // //   RadioGroup,
// // //   FormControlLabel,
// // //   Radio,
// // //   InputAdornment,
// // //   Alert,
// // //   IconButton,
// // // } from "@mui/material";
// // // import { SketchPicker } from "react-color";
// // // import axiosClient from "../axiosClient";
// // // import { useTranslation } from "react-i18next";
// // // import PhoneField from "../components/PhoneField";
// // // import { Visibility, VisibilityOff } from "@mui/icons-material";

// // // const UserForm = () => {
// // //   const nameRef = useRef(null);
// // //   const surnameRef = useRef(null);
// // //   const dateRef = useRef(null);
// // //   const passwordRef = useRef(null);
// // //   const emailRef = useRef(null);
// // //   const cityRef = useRef(null);
// // //   const specializationsRef = useRef(null);

// // //   const [gender, setGender] = useState("");
// // //   const [role, setRole] = useState("TECHNICIAN");
// // //   const [error, setError] = useState();
// // //   const [message, setMessage] = useState();
// // //   const [color, setColor] = useState("#3f51b5");
// // //   const [phone, setPhone] = useState("+357");
// // //   const [errors, setErrors] = useState({});
// // //   const { t } = useTranslation();
// // //   const [showPassword, setShowPassword] = useState(false);

// // //   // Normalizes the phone number to strip spaces/dashes for the backend
// // //   const normalizePhone = (value) => {
// // //     if (!value) return "";
// // //     const cleanNumber = String(value).replace(/[\s\-\(\)]/g, ""); 
// // //     if (cleanNumber === "+357") return "";
// // //     return cleanNumber.startsWith("+") ? cleanNumber : `+${cleanNumber}`;
// // //   };

// // //   const handleSubmit = (event) => {
// // //     event.preventDefault();
// // //     setErrors({});
// // //     setError(undefined);
// // //     setMessage(undefined);

// // //     const emailVal = emailRef.current?.value || "";
// // //     const passwordVal = passwordRef.current?.value || "";
// // //     const phoneVal = normalizePhone(phone);

// // //     // Front-end basic validation
// // //     const localErrors = {};
// // //     if (!emailVal) localErrors.email = t("Email is required");
// // //     if (passwordVal.length < 8) localErrors.password = t("Min 8 characters");
// // //     if (!phoneVal || phoneVal === "+357") localErrors.phone_number = t("Phone is required");

// // //     if (Object.keys(localErrors).length) {
// // //       setErrors(localErrors);
// // //       return;
// // //     }

// // //     const payload = {
// // //       user_role: role,
// // //       username: emailVal, // Backend requires a username; using email is standard here
// // //       email: emailVal,
// // //       password: passwordVal,
// // //       first_name: nameRef.current?.value || "",
// // //       last_name: surnameRef.current?.value || "",
// // //       phone_number: phoneVal,
// // //       gender: gender || null,
// // //       date_birth: dateRef.current?.value || null,
// // //       city: cityRef.current?.value || "",
// // //       ...((role === "TECHNICIAN" || role === "MAID")
// // //         ? { color: color, specializations: specializationsRef.current?.value || "" }
// // //         : {})
// // //     };

// // //     console.log("Sending Payload:", payload);

// // //     axiosClient.post("auth/users/", payload)
// // //       .then(() => {
// // //         setMessage(t("User added successfully"));
// // //         handleReset();
// // //       })
// // //       .catch((err) => {
// // //         const backendMsg = err.response?.data;
// // //         console.error("Backend Error:", backendMsg);
// // //         // Show specific error (like "Email already exists" or "Invalid Phone")
// // //         setError(backendMsg ? JSON.stringify(backendMsg) : t("Failed to create user."));
// // //         if (backendMsg) setErrors(backendMsg);
// // //       });
// // //   };

// // //   const handleReset = () => {
// // //     setRole("TECHNICIAN");
// // //     setGender("");
// // //     setPhone("+357");
// // //     setErrors({});
// // //     [nameRef, surnameRef, dateRef, passwordRef, emailRef, cityRef, specializationsRef].forEach(ref => {
// // //       if (ref.current) ref.current.value = "";
// // //     });
// // //   };

// // //   return (
// // //     <Card elevation={16}>
// // //       <CardContent>
// // //         <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
// // //           {t("Create New User")}
// // //         </Typography>

// // //         {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // //         {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// // //         <form onSubmit={handleSubmit}>
// // //           <Box display="flex" alignItems="center" sx={{ mb: 3 }}>
// // //             <FormLabel sx={{ mr: 2, fontWeight: 'bold' }}>{t("Role")}</FormLabel>
// // //             <RadioGroup row value={role} onChange={(e) => setRole(e.target.value)}>
// // //               <FormControlLabel value="RECEPTION" control={<Radio />} label={t("Reception")} />
// // //               <FormControlLabel value="ADMIN" control={<Radio />} label={t("Admin")} />
// // //               <FormControlLabel value="TECHNICIAN" control={<Radio />} label={t("Technician")} />
// // //               <FormControlLabel value="MAID" control={<Radio />} label={t("Maid")} />
// // //             </RadioGroup>
// // //           </Box>

// // //           <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
// // //             <TextField fullWidth label={t("Name")} inputRef={nameRef} required />
// // //             <TextField fullWidth label={t("Surname")} inputRef={surnameRef} required />
// // //             <TextField 
// // //               fullWidth 
// // //               label={t("Email")} 
// // //               type="email" 
// // //               inputRef={emailRef} 
// // //               required 
// // //               error={!!errors.email}
// // //               helperText={errors.email}
// // //             />
// // //             <TextField
// // //               fullWidth
// // //               label={t("Password")}
// // //               type={showPassword ? "text" : "password"}
// // //               inputRef={passwordRef}
// // //               required
// // //               error={!!errors.password}
// // //               helperText={errors.password}
// // //               InputProps={{
// // //                 endAdornment: (
// // //                   <InputAdornment position="end">
// // //                     <IconButton onClick={() => setShowPassword(!showPassword)}>
// // //                       {showPassword ? <VisibilityOff /> : <Visibility />}
// // //                     </IconButton>
// // //                   </InputAdornment>
// // //                 ),
// // //               }}
// // //             />
// // //             <Box>
// // //               <PhoneField phone={phone} setPhone={setPhone} />
// // //               {(errors.phone_number || errors.phone) && (
// // //                 <Typography color="error" variant="caption" sx={{ ml: 1 }}>
// // //                   {t("The phone number entered is not valid.")}
// // //                 </Typography>
// // //               )}
// // //             </Box>
// // //             <TextField fullWidth label={t("City")} inputRef={cityRef} />
// // //           </Box>

// // //           {(role === "TECHNICIAN" || role === "MAID") && (
// // //             <Box sx={{ mt: 3, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
// // //               <TextField 
// // //                 fullWidth 
// // //                 label={t("Specializations")} 
// // //                 inputRef={specializationsRef} 
// // //                 sx={{ mb: 2 }} 
// // //               />
// // //               <Typography variant="caption" sx={{ display: 'block', mb: 1 }}>
// // //                 {t("Calendar Color Selection")}
// // //               </Typography>
// // //               <SketchPicker color={color} onChangeComplete={(c) => setColor(c.hex)} />
// // //             </Box>
// // //           )}

// // //           <Box mt={4} display="flex" gap={2}>
// // //             <Button type="submit" variant="contained" size="large">{t("SUBMIT")}</Button>
// // //             <Button type="button" variant="outlined" size="large" onClick={handleReset}>{t("RESET")}</Button>
// // //           </Box>
// // //         </form>
// // //       </CardContent>
// // //     </Card>
// // //   );
// // // };

// // // export default UserForm;

// // import GDPRPolicyLink from "../components/GDPRPolicyLink";
// // import { useState, useRef } from "react";
// // import {
// //   Card,
// //   CardContent,
// //   Typography,
// //   TextField,
// //   Button,
// //   Box,
// //   FormLabel,
// //   RadioGroup,
// //   FormControlLabel,
// //   Radio,
// //   InputAdornment,
// //   Alert,
// //   IconButton,
// // } from "@mui/material";
// // import { SketchPicker } from "react-color";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";
// // import PhoneField from "../components/PhoneField";
// // import { Visibility, VisibilityOff } from "@mui/icons-material";

// // const UserForm = () => {
// //   const nameRef = useRef(null);
// //   const surnameRef = useRef(null);
// //   const passwordRef = useRef(null);
// //   const emailRef = useRef(null);
// //   const cityRef = useRef(null);
// //   const specializationsRef = useRef(null);

// //   const [role, setRole] = useState("TECHNICIAN");
// //   const [error, setError] = useState();
// //   const [message, setMessage] = useState();
// //   const [color, setColor] = useState("#3f51b5");
// //   const [phone, setPhone] = useState("+357");
// //   const [errors, setErrors] = useState({});
// //   const { t } = useTranslation();
// //   const [showPassword, setShowPassword] = useState(false);

// //   // Cleans the phone number string for the backend
// //   const normalizePhone = (value) => {
// //     if (!value) return "";
// //     // Remove all non-numeric characters except the leading '+'
// //     const cleanNumber = String(value).replace(/[^\d+]/g, ""); 
// //     if (cleanNumber === "+357" || cleanNumber === "+") return "";
// //     return cleanNumber.startsWith("+") ? cleanNumber : `+${cleanNumber}`;
// //   };

// //   const handleSubmit = (event) => {
// //     event.preventDefault();
// //     console.log("Submit clicked!");
    
// //     setErrors({});
// //     setError(undefined);
// //     setMessage(undefined);

// //     const emailVal = emailRef.current?.value || "";
// //     const passwordVal = passwordRef.current?.value || "";
// //     const phoneVal = normalizePhone(phone);

// //     // Front-end local validation
// //     const localErrors = {};
// //     if (!emailVal) localErrors.email = t("Email is required");
// //     if (passwordVal.length < 8) localErrors.password = t("Min 8 characters");
// //     if (!phoneVal) localErrors.phone_number = t("Phone is required");

// //     if (Object.keys(localErrors).length) {
// //       setErrors(localErrors);
// //       console.log("Validation errors:", localErrors);
// //       return;
// //     }

// //     const payload = {
// //       user_role: role,
// //       username: emailVal, 
// //       email: emailVal,
// //       password: passwordVal,
// //       first_name: nameRef.current?.value || "",
// //       last_name: surnameRef.current?.value || "",
// //       phone_number: phoneVal,
// //       city: cityRef.current?.value || "",
// //       ...((role === "TECHNICIAN" || role === "MAID")
// //         ? { color: color, specializations: specializationsRef.current?.value || "" }
// //         : {})
// //     };

// //     console.log("Sending Payload:", payload);

// //     axiosClient.post("auth/users/", payload)
// //       .then(() => {
// //         setMessage(t("User added successfully"));
// //         handleReset();
// //       })
// //       .catch((err) => {
// //         const backendMsg = err.response?.data;
// //         console.error("Backend Error Detail:", backendMsg);
        
// //         // Handle specific field errors from backend (like invalid phone or duplicate email)
// //         if (backendMsg) {
// //           setErrors(backendMsg);
// //           setError(JSON.stringify(backendMsg));
// //         } else {
// //           setError(t("Server error. Please try again later."));
// //         }
// //       });
// //   };

// //   const handleReset = () => {
// //     setRole("TECHNICIAN");
// //     setPhone("+357");
// //     setErrors({});
// //     [nameRef, surnameRef, passwordRef, emailRef, cityRef, specializationsRef].forEach(ref => {
// //       if (ref.current) ref.current.value = "";
// //     });
// //   };

// //   return (
// //     <Card elevation={16}>
// //       <CardContent>
// //         <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
// //           {t("Create New User")}
// //         </Typography>

// //         {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// //         {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// //         <form onSubmit={handleSubmit}>
// //           <Box sx={{ mb: 3 }}>
// //             <FormLabel sx={{ fontWeight: 'bold', color: 'white' }}>{t("ROLE")}</FormLabel>
// //             <RadioGroup row value={role} onChange={(e) => setRole(e.target.value)}>
// //               <FormControlLabel value="RECEPTION" control={<Radio />} label={t("Reception")} />
// //               <FormControlLabel value="ADMIN" control={<Radio />} label={t("Admin")} />
// //               <FormControlLabel value="TECHNICIAN" control={<Radio />} label={t("Technician")} />
// //               <FormControlLabel value="MAID" control={<Radio />} label={t("Maid")} />
// //             </RadioGroup>
// //           </Box>

// //           <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
// //             <TextField fullWidth label={t("NAME *")} inputRef={nameRef} required />
// //             <TextField fullWidth label={t("SURNAME *")} inputRef={surnameRef} required />
// //             <TextField 
// //               fullWidth 
// //               label={t("EMAIL *")} 
// //               inputRef={emailRef} 
// //               required 
// //               error={!!errors.email}
// //               helperText={errors.email}
// //             />
// //             <TextField
// //               fullWidth
// //               label={t("PASSWORD *")}
// //               type={showPassword ? "text" : "password"}
// //               inputRef={passwordRef}
// //               required
// //               error={!!errors.password}
// //               helperText={errors.password}
// //               InputProps={{
// //                 endAdornment: (
// //                   <InputAdornment position="end">
// //                     <IconButton onClick={() => setShowPassword(!showPassword)}>
// //                       {showPassword ? <VisibilityOff /> : <Visibility />}
// //                     </IconButton>
// //                   </InputAdornment>
// //                 ),
// //               }}
// //             />
// //             <Box>
// //               <PhoneField phone={phone} setPhone={setPhone} />
// //               {errors.phone_number && (
// //                 <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
// //                   {t("The phone number entered is not valid.")}
// //                 </Typography>
// //               )}
// //             </Box>
// //             <TextField fullWidth label={t("CITY")} inputRef={cityRef} />
// //           </Box>

// //           {(role === "TECHNICIAN" || role === "MAID") && (
// //             <Box sx={{ mt: 3, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
// //               <TextField 
// //                 fullWidth 
// //                 label={t("Specializations")} 
// //                 inputRef={specializationsRef} 
// //                 sx={{ mb: 2, input: { color: 'black' }, label: { color: 'gray' } }} 
// //               />
// //               <Typography variant="caption" sx={{ display: 'block', mb: 1, color: 'gray' }}>
// //                 {t("Calendar Color Selection")}
// //               </Typography>
// //               <SketchPicker color={color} onChangeComplete={(c) => setColor(c.hex)} />
// //             </Box>
// //           )}

// //           <Box mt={4} display="flex" gap={2}>
// //             <Button type="submit" variant="contained" size="large">{t("SUBMIT")}</Button>
// //             <Button type="button" variant="outlined" size="large" onClick={handleReset}>{t("RESET")}</Button>
// //           </Box>
// //         </form>
// //       </CardContent>
// //     </Card>
// //   );
// // };

// // export default UserForm;

// import GDPRPolicyLink from "../components/GDPRPolicyLink";
// import { useState, useRef } from "react";
// import {
//   Card,
//   CardContent,
//   Typography,
//   TextField,
//   Button,
//   Box,
//   FormLabel,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   InputAdornment,
//   Alert,
//   IconButton,
// } from "@mui/material";
// import { SketchPicker } from "react-color";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";
// import PhoneField from "../components/PhoneField";
// import { Visibility, VisibilityOff } from "@mui/icons-material";

// const UserForm = () => {
//   const nameRef = useRef(null);
//   const surnameRef = useRef(null);
//   const passwordRef = useRef(null);
//   const emailRef = useRef(null);
//   const cityRef = useRef(null);
//   const specializationsRef = useRef(null);

//   const [role, setRole] = useState("TECHNICIAN");
//   const [error, setError] = useState();
//   const [message, setMessage] = useState();
//   const [color, setColor] = useState("#3f51b5");
//   const [phone, setPhone] = useState("+357");
//   const [errors, setErrors] = useState({});
//   const { t } = useTranslation();
//   const [showPassword, setShowPassword] = useState(false);

//   // Cleans the phone number string for the backend
//   const normalizePhone = (value) => {
//     if (!value) return "";
//     // Remove all non-numeric characters except the leading '+'
//     const cleanNumber = String(value).replace(/[^\d+]/g, ""); 
//     if (cleanNumber === "+357" || cleanNumber === "+") return "";
//     return cleanNumber.startsWith("+") ? cleanNumber : `+${cleanNumber}`;
//   };

//   const handleSubmit = (event) => {
//     event.preventDefault();
//     console.log("Submit clicked!");
    
//     setErrors({});
//     setError(undefined);
//     setMessage(undefined);

//     const emailVal = emailRef.current?.value || "";
//     const passwordVal = passwordRef.current?.value || "";
//     const phoneVal = normalizePhone(phone);

//     // Front-end local validation
//     const localErrors = {};
//     if (!emailVal) localErrors.email = t("Email is required");
//     if (passwordVal.length < 8) localErrors.password = t("Min 8 characters");
//     if (!phoneVal) localErrors.phone_number = t("Phone is required");

//     if (Object.keys(localErrors).length) {
//       setErrors(localErrors);
//       console.log("Validation errors:", localErrors);
//       return;
//     }

//     const payload = {
//       user_role: role,
//       username: emailVal, 
//       email: emailVal,
//       password: passwordVal,
//       first_name: nameRef.current?.value || "",
//       last_name: surnameRef.current?.value || "",
//       phone_number: phoneVal,
//       city: cityRef.current?.value || "",
//       ...((role === "TECHNICIAN" || role === "MAID")
//         ? { color: color, specializations: specializationsRef.current?.value || "" }
//         : {})
//     };

//     console.log("Sending Payload:", payload);

//     axiosClient.post("auth/users/", payload)
//       .then(() => {
//         setMessage(t("User added successfully"));
//         handleReset();
//       })
//       .catch((err) => {
//         const backendMsg = err.response?.data;
//         console.error("Backend Error Detail:", backendMsg);
        
//         // Handle specific field errors from backend (like invalid phone or duplicate email)
//         if (backendMsg) {
//           setErrors(backendMsg);
//           setError(JSON.stringify(backendMsg));
//         } else {
//           setError(t("Server error. Please try again later."));
//         }
//       });
//   };

//   const handleReset = () => {
//     setRole("TECHNICIAN");
//     setPhone("+357");
//     setErrors({});
//     [nameRef, surnameRef, passwordRef, emailRef, cityRef, specializationsRef].forEach(ref => {
//       if (ref.current) ref.current.value = "";
//     });
//   };

//   return (
//     <Card elevation={16}>
//       <CardContent>
//         <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
//           {t("Create New User")}
//         </Typography>

//         {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
//         {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

//         <form onSubmit={handleSubmit}>
//           <Box sx={{ mb: 3 }}>
//             <FormLabel sx={{ fontWeight: 'bold', color: 'white' }}>{t("ROLE")}</FormLabel>
//             <RadioGroup row value={role} onChange={(e) => setRole(e.target.value)}>
//               <FormControlLabel value="RECEPTION" control={<Radio />} label={t("Reception")} />
//               <FormControlLabel value="ADMIN" control={<Radio />} label={t("Admin")} />
//               <FormControlLabel value="TECHNICIAN" control={<Radio />} label={t("Technician")} />
//               <FormControlLabel value="MAID" control={<Radio />} label={t("Maid")} />
//             </RadioGroup>
//           </Box>

//           <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
//             <TextField fullWidth label={t("NAME *")} inputRef={nameRef} required />
//             <TextField fullWidth label={t("SURNAME *")} inputRef={surnameRef} required />
//             <TextField 
//               fullWidth 
//               label={t("EMAIL *")} 
//               inputRef={emailRef} 
//               required 
//               error={!!errors.email}
//               helperText={errors.email}
//             />
//             <TextField
//               fullWidth
//               label={t("PASSWORD *")}
//               type={showPassword ? "text" : "password"}
//               inputRef={passwordRef}
//               required
//               error={!!errors.password}
//               helperText={errors.password}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton onClick={() => setShowPassword(!showPassword)}>
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <Box>
//               <PhoneField phone={phone} setPhone={setPhone} />
//               {errors.phone_number && (
//                 <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
//                   {t("The phone number entered is not valid.")}
//                 </Typography>
//               )}
//             </Box>
//             <TextField fullWidth label={t("CITY")} inputRef={cityRef} />
//           </Box>

//           {(role === "TECHNICIAN" || role === "MAID") && (
//             <Box sx={{ mt: 3, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
//               <TextField 
//                 fullWidth 
//                 label={t("Specializations")} 
//                 inputRef={specializationsRef} 
//                 sx={{ mb: 2, input: { color: 'black' }, label: { color: 'gray' } }} 
//               />
//               <Typography variant="caption" sx={{ display: 'block', mb: 1, color: 'gray' }}>
//                 {t("Calendar Color Selection")}
//               </Typography>
//               <SketchPicker color={color} onChangeComplete={(c) => setColor(c.hex)} />
//             </Box>
//           )}

//           <Box mt={4} display="flex" gap={2}>
//             <Button type="submit" variant="contained" size="large">{t("SUBMIT")}</Button>
//             <Button type="button" variant="outlined" size="large" onClick={handleReset}>{t("RESET")}</Button>
//           </Box>
//         </form>
//       </CardContent>
//     </Card>
//   );
// };

// export default UserForm;

import GDPRPolicyLink from "../components/GDPRPolicyLink";
import { useState, useRef } from "react";
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Box,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputAdornment,
  Alert,
  IconButton,
} from "@mui/material";
import { SketchPicker } from "react-color";
import axiosClient from "../axiosClient";
import { useTranslation } from "react-i18next";
import PhoneField from "../components/PhoneField";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const UserForm = () => {
  const nameRef = useRef(null);
  const surnameRef = useRef(null);
  const passwordRef = useRef(null);
  const emailRef = useRef(null);
  const cityRef = useRef(null);
  const specializationsRef = useRef(null);

  const [role, setRole] = useState("TECHNICIAN");
  const [error, setError] = useState();
  const [message, setMessage] = useState();
  const [color, setColor] = useState("#3f51b5");
  const [phone, setPhone] = useState("+357");
  const [errors, setErrors] = useState({});
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  // Cleans the phone number string for the backend
  const normalizePhone = (value) => {
    if (!value) return "";
    const cleanNumber = String(value).replace(/[^\d+]/g, ""); 
    if (cleanNumber === "+357" || cleanNumber === "+") return "";
    return cleanNumber.startsWith("+") ? cleanNumber : `+${cleanNumber}`;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    
    // Clear previous feedback
    setErrors({});
    setError(undefined);
    setMessage(undefined);

    const emailVal = emailRef.current?.value || "";
    const passwordVal = passwordRef.current?.value || "";
    const phoneVal = normalizePhone(phone);

    // Front-end local validation
    const localErrors = {};
    if (!emailVal) localErrors.email = t("Email is required");
    if (passwordVal.length < 8) localErrors.password = t("Min 8 characters");
    if (!phoneVal) localErrors.phone_number = t("Phone is required");

    if (Object.keys(localErrors).length) {
      setErrors(localErrors);
      return;
    }

    const payload = {
      user_role: role,
      username: emailVal, 
      email: emailVal,
      password: passwordVal,
      first_name: nameRef.current?.value || "",
      last_name: surnameRef.current?.value || "",
      phone_number: phoneVal,
      city: cityRef.current?.value || "",
      ...((role === "TECHNICIAN" || role === "MAID")
        ? { color: color, specializations: specializationsRef.current?.value || "" }
        : {})
    };

    axiosClient.post("auth/users/", payload)
      .then(() => {
        // Success! Set the message first
        setMessage(t("User added successfully"));
        
        // Manual reset of fields instead of calling handleReset()
        // This keeps the 'role' state as it is so the UI doesn't jump
        if (nameRef.current) nameRef.current.value = "";
        if (surnameRef.current) surnameRef.current.value = "";
        if (emailRef.current) emailRef.current.value = "";
        if (passwordRef.current) passwordRef.current.value = "";
        if (cityRef.current) cityRef.current.value = "";
        if (specializationsRef.current) specializationsRef.current.value = "";
        
        // Clear phone and errors, but keep the role and color
        setPhone("+357");
        setErrors({});

        // Scroll to the top of the form so the success alert is visible
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
      .catch((err) => {
        const backendMsg = err.response?.data;
        if (backendMsg) {
          setErrors(backendMsg);
          setError(JSON.stringify(backendMsg));
        } else {
          setError(t("Server error. Please try again later."));
        }
      });
  };

  const handleReset = () => {
    setRole("TECHNICIAN");
    setPhone("+357");
    setErrors({});
    setMessage(undefined);
    setError(undefined);
    [nameRef, surnameRef, passwordRef, emailRef, cityRef, specializationsRef].forEach(ref => {
      if (ref.current) ref.current.value = "";
    });
  };

  return (
    <Card elevation={16}>
      <CardContent>
        <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
          {t("Create New User")}
        </Typography>

        {/* Alerts are positioned outside the form for maximum visibility */}
        {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <form onSubmit={handleSubmit}>
          <Box sx={{ mb: 3 }}>
            <FormLabel sx={{ fontWeight: 'bold' }}>{t("ROLE")}</FormLabel>
            <RadioGroup row value={role} onChange={(e) => setRole(e.target.value)}>
              <FormControlLabel value="RECEPTION" control={<Radio />} label={t("Reception")} />
              <FormControlLabel value="ADMIN" control={<Radio />} label={t("Admin")} />
              <FormControlLabel value="TECHNICIAN" control={<Radio />} label={t("Technician")} />
              <FormControlLabel value="MAID" control={<Radio />} label={t("Maid")} />
            </RadioGroup>
          </Box>

          <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
            <TextField fullWidth label={t("NAME *")} inputRef={nameRef} required />
            <TextField fullWidth label={t("SURNAME *")} inputRef={surnameRef} required />
            <TextField 
              fullWidth 
              label={t("EMAIL *")} 
              inputRef={emailRef} 
              required 
              error={!!errors.email}
              helperText={errors.email}
            />
            <TextField
              fullWidth
              label={t("PASSWORD *")}
              type={showPassword ? "text" : "password"}
              inputRef={passwordRef}
              required
              error={!!errors.password}
              helperText={errors.password}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Box>
              <PhoneField phone={phone} setPhone={setPhone} />
              {errors.phone_number && (
                <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
                  {t("The phone number entered is not valid.")}
                </Typography>
              )}
            </Box>
            <TextField fullWidth label={t("CITY")} inputRef={cityRef} />
          </Box>

          {(role === "TECHNICIAN" || role === "MAID") && (
            <Box sx={{ mt: 3, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
              <TextField 
                fullWidth 
                label={t("Specializations")} 
                inputRef={specializationsRef} 
                sx={{ mb: 2, input: { color: 'black' }, label: { color: 'gray' } }} 
              />
              <Typography variant="caption" sx={{ display: 'block', mb: 1, color: 'gray' }}>
                {t("Calendar Color Selection")}
              </Typography>
              <SketchPicker color={color} onChangeComplete={(c) => setColor(c.hex)} />
            </Box>
          )}

          <Box mt={4} display="flex" gap={2}>
            <Button type="submit" variant="contained" size="large">{t("SUBMIT")}</Button>
            <Button type="button" variant="outlined" size="large" onClick={handleReset}>{t("RESET")}</Button>
          </Box>
        </form>
      </CardContent>
    </Card>
  );
};

export default UserForm;